/* V48B_FINAL_FILTER_ORDER_FIX */
/* V48_DYNAMIC_NAV_ONLY */
/* V47_MULTIGAME_PRESENTATION */
(function(){
'use strict';
/* BURRO_FINAL_METADATA_LINKS_CANONICAL_20260828 */

const q=(r,s)=>r.querySelector(s);
const qa=(r,s)=>Array.from(r.querySelectorAll(s));
const esc=s=>String(s??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[c]));
const arr=p=>Array.isArray(p)?p:(p?.records||p?.cards||p?.sets||p?.data||[]);
/* V46D_CANONICAL_GAME_ROUTER */
const gameKey=s=>{
  const raw=String(s||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').trim().toLowerCase();
  const compact=raw.replace(/[^a-z0-9]+/g,'');
  const aliases={
    mtg:'mtg',magic:'mtg',magicthegathering:'mtg',
    pokemon:'pokemon',pokemontcg:'pokemon',pkm:'pokemon',
    ygo:'ygo',yugioh:'ygo',yugiohtcg:'ygo',
    riftbound:'riftbound',riftboundtcg:'riftbound',

    onepiece:'onepiece',onepiececardgame:'onepiece',op:'onepiece',opcg:'onepiece',
    fab:'fab',fleshandblood:'fab',fleshandbloodtcg:'fab',
    lorcana:'lorcana',disneylorcana:'lorcana',lorcanatcg:'lorcana',
    digimon:'digimon',digimontcg:'digimon',digimoncardgame:'digimon',

    swu:'swu',starwars:'swu',starwarsunlimited:'swu',starwarsunlimitedtcg:'swu',

    gundam:'gundam',gundamtcg:'gundam',gundamcardgame:'gundam',

    dbfw:'dbfw',dbsfw:'dbfw',dbsfusionworld:'dbfw',dbscgfusionworld:'dbfw',dragonballsuperfusionworld:'dbfw',fusionworld:'dbfw',dbsfw:'dbfw',dbsfusionworld:'dbfw',dbscgfusionworld:'dbfw',
    dragonballsuperfusionworld:'dbfw',fusionworld:'dbfw',

    dbm:'dbm',dbsm:'dbm',dbsmasters:'dbm',dbscgmasters:'dbm',dragonballsupermasters:'dbm',dragonballsupercardgame:'dbm',dragonballsuperccg:'dbm',dbsm:'dbm',dbsmasters:'dbm',dbscgmasters:'dbm',
    dragonballsupermasters:'dbm',dragonballsupercardgame:'dbm',
    dbs:'dbm',masters:'dbm'
  };
  return aliases[compact]||compact;
};
const norm=s=>String(s||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().trim();
const titleCase=s=>String(s||'').replace(/[_-]+/g,' ').replace(/\b\w/g,m=>m.toUpperCase());
const yearOf=s=>{
  const raw=s?.display_year||s?.released_at||s?.release_date||s?.releasedAt||s?.releaseDate||
    s?.metadata?.released_at||s?.metadata?.release_date||'';
  const m=String(raw).match(/(?:19|20)\d{2}/);
  return m?m[0]:'';
};
const countOf=s=>Number(s?.count??s?.card_count??s?.cards)||0;
const collector=c=>String(c?.collector_number||c?.card_number||c?.number||'');
const collectorQuery=s=>{
  const raw=String(s||'').trim();
  const m=raw.match(/^#?\s*([A-Za-z0-9.-]+)\s*(?:\/\s*(\d+))?\s*$/);
  if(!m)return null;
  // Avoid treating ordinary alphabetic words as collector numbers.
  if(!/\d/.test(m[1]))return null;
  return {number:String(m[1]).trim(),total:m[2]?Number(m[2]):null,raw};
};
const collectorKey=s=>String(s||'').trim().toLowerCase().replace(/^0+(?=\d)/,'');
const collectorMatches=(card,q)=>{
  if(!q)return false;
  const raw=collector(card);
  if(!raw)return false;
  const first=String(raw).split('/')[0].trim();
  return collectorKey(first)===collectorKey(q.number);
};

const setCode=c=>{
  const direct=c?.set_code||c?.setCode||c?.expansion_code||c?.expansionCode;
  if(direct)return String(direct).toUpperCase();

  if(typeof c?.set==='string')return String(c.set).toUpperCase();
  if(c?.set&&typeof c.set==='object'){
    const nested=c.set.code||c.set.set_code||c.set.id||c.set.slug;
    if(nested)return String(nested).toUpperCase();
  }

  if(c?.expansion&&typeof c.expansion==='object'){
    const nested=c.expansion.code||c.expansion.set_code||c.expansion.id||c.expansion.slug;
    if(nested)return String(nested).toUpperCase();
  }

  // Los registros de búsqueda global de MTG pueden traer las expansiones
  // como array `sets:[...]` en lugar de `set_code`.
  if(Array.isArray(c?.sets)&&c.sets.length){
    const first=c.sets[0];
    if(typeof first==='string')return String(first).toUpperCase();
    if(first&&typeof first==='object'){
      const nested=first.code||first.set_code||first.id||first.slug;
      if(nested)return String(nested).toUpperCase();
    }
  }

  return '';
};

const faceArray=c=>{
  if(Array.isArray(c?.card_faces))return c.card_faces;
  if(Array.isArray(c?.faces))return c.faces;
  if(Array.isArray(c?.cardFaces))return c.cardFaces;
  return [];
};
const imageFromFace=f=>{
  if(!f)return'';
  if(typeof f.image==='string')return f.image;
  return f?.image?.normal||f?.image?.large||f?.image?.small||
    f?.image_uris?.normal||f?.image_uris?.large||f?.image_uris?.small||
    f?.images?.normal||f?.images?.large||f?.images?.small||'';
};
const frontImage=c=>{
  const faces=faceArray(c);
  if(faces.length&&imageFromFace(faces[0]))return imageFromFace(faces[0]);

  const direct=[
    c?.image_url,c?.imageUrl,c?.card_image,c?.cardImage,c?.front_image_url,
    imageFromObject(c?.front_image),imageFromObject(c?.image_front),
    imageFromObject(c?.images?.front),imageFromObject(c?.image),
    imageFromObject(c?.images),
    c?.metadata?.image_url,c?.metadata?.imageUrl,
    imageFromObject(c?.metadata?.image),
    c?.assets?.image,c?.assets?.card,
    c?.raw?.image_url,c?.source?.image_url,c?.data?.image_url,
    c?.image_uris?.normal,c?.image_uris?.large,
    c?.art_full_url,c?.art_thumbnail_url
  ].find(u=>/^https?:\/\//i.test(String(u||'')));
  if(direct)return direct;

  const tcgId=c?.tcgplayer_id||c?.tcgplayer_product_id||
    c?.metadata?.tcgplayer_id||c?.metadata?.tcgplayer_product_id;
  if(/^\d+$/.test(String(tcgId||''))){
    return `https://product-images.tcgplayer.com/fit-in/400x400/${String(tcgId)}.jpg`;
  }
  return'';
};

const imageFromVariantList=imgs=>{
  const rows=Array.isArray(imgs)?imgs:[];
  const front=rows.find(x=>String(x?.type||'front').toLowerCase()==='front')||rows[0];
  if(!front)return'';
  return front.large||front.medium||front.normal||front.small||'';
};
const variantImageForFinish=(c,finish)=>{
  if(!c||!finish)return'';
  const wanted=String(finish).toLowerCase().replace(/[\s_-]+/g,'');
  const map=c?.metadata?.variant_images||c?.variant_images||{};
  for(const [raw,imgs] of Object.entries(map||{})){
    const key=String(raw).toLowerCase().replace(/[\s_-]+/g,'');
    if(key===wanted)return imageFromVariantList(imgs);
  }
  return'';
};
const displayImageForCard=(c,state)=>{
  if(state?.game==='pokemon'){
    const selected=state?.facets?.finishes||[];
    if(selected.length===1){
      const img=variantImageForFinish(c,selected[0]);
      if(img)return img;
    }
  }
  return frontImage(c);
};
const imageFromObject=v=>{
  if(!v)return'';
  if(typeof v==='string')return /^https?:\/\//i.test(v)?v:'';
  return v.normal||v.large||v.medium||v.png||v.small||v.url||v.image_url||v.imageUrl||'';
};
const backImage=c=>{
  const faces=faceArray(c);
  if(faces.length>1&&imageFromFace(faces[1]))return imageFromFace(faces[1]);
  if(c?.image_back)return imageFromObject(c.image_back);
  if(c?.back_image)return imageFromObject(c.back_image);
  if(c?.backImage)return imageFromObject(c.backImage);
  if(c?.images?.back)return imageFromObject(c.images.back);
  if(c?.back?.image)return imageFromObject(c.back.image);
  return '';
};
const faceName=(c,index)=>{
  const f=faceArray(c)[index];
  if(f?.name)return f.name;
  if(index===0 && c?.front_name)return c.front_name;
  if(index===1 && c?.back_name)return c.back_name;
  const parts=String(c?.name||'').split(/\s*\/\/\s*/);
  return parts[index]||c?.name||'';
};
const faceType=(c,index)=>{
  const f=faceArray(c)[index];
  if(f?.type_line||f?.card_type||f?.type)return f.type_line||f.card_type||f.type;
  if(index===0)return c?.front_type_line||c?.front_card_type||'';
  if(index===1)return c?.back_type_line||c?.back_card_type||'';
  return '';
};
const cardTypeValues=c=>{
  const vals=[];
  const faces=faceArray(c);
  if(faces.length){
    faces.forEach(f=>{
      const t=f?.type_line||f?.card_type||f?.type;
      if(t)vals.push(String(t));
    });
  }
  if(c?.front_type_line)vals.push(String(c.front_type_line));
  if(c?.back_type_line)vals.push(String(c.back_type_line));
  if(c?.front_card_type)vals.push(String(c.front_card_type));
  if(c?.back_card_type)vals.push(String(c.back_card_type));

  // Fallback for flattened double-faced records.
  if(!vals.length){
    const top=String(c?.type_line||c?.card_type||'');
    top.split(/\s*\/\/\s*/).map(x=>x.trim()).filter(Boolean).forEach(x=>vals.push(x));
  }

  return [...new Set(vals.filter(Boolean))];
};
const displayCardTypes=c=>{
  const vals=cardTypeValues(c);
  return vals.length?vals.join(' // '):(c?.type_line||c?.card_type||'—');
};
const hasBackFace=c=>{
  if(typeof c?.has_physical_back==='boolean')return c.has_physical_back;
  const layout=String(c?.layout||'').toLowerCase();
  return ['transform','modal_dfc','reversible_card','double_faced_token'].includes(layout);
};
const canFlipCard=c=>{
  if(typeof c?.can_flip==='boolean')return c.can_flip;
  return hasBackFace(c)&&Boolean(backImage(c));
};
const stockOf=c=>{
  if(typeof c?._commerce?.in_stock==='boolean')return c._commerce.in_stock;
  if(typeof c?.in_stock==='boolean')return c.in_stock;
  for(const k of ['inventory','stock','quantity']){
    const n=Number(c?._commerce?.[k] ?? c?.[k]); if(Number.isFinite(n))return n>0;
  }
  return null;
};
const inventoryOf=c=>{
  const n=Number(c?._commerce?.inventory ?? c?.inventory ?? c?.stock ?? c?.quantity);
  return Number.isFinite(n)?n:null;
};
const productUrlOf=c=>String(c?._commerce?.product_url||'').trim();
const shopifyVariantId=v=>{
  const raw=String(v?.shopify_variant_id||v?.variant_numeric_id||v?.variant_id||v?.admin_graphql_api_id||v?.id||'').trim();
  if(!raw)return '';
  const m=raw.match(/(\d+)$/);
  return m?m[1]:raw;
};
const liveVariantsOf=c=>(Array.isArray(c?._commerce?.variants)?c._commerce.variants:[])
  .filter(v=>Number(v?.inventory||0)>0 && v?.available!==false && shopifyVariantId(v));
const finishLabel=v=>{
  const raw=String(v||'');
  const x=raw.toLowerCase().replace(/[\s_-]+/g,'');
  if(['nonfoil','regular','normal'].includes(x))return 'Regular';
  if(x==='foil')return 'Foil';
  if(x==='etched')return 'Etched';
  if(['holo','holofoil'].includes(x))return 'Holo';
  if(['reverseholo','reverseholofoil'].includes(x))return 'Reverse Holo';
  if(['stamped','stamp','whatstyourfavoritestamp','whatsyourfavoritestamp'].includes(x))return 'Stamp';
  return titleCase(raw);
};
const optionValuesOf=v=>{
  if(Array.isArray(v?.selected_options)){
    const vals=v.selected_options.map(x=>typeof x==='object'?(x?.value??x?.name):x).filter(Boolean);
    if(vals.length)return vals;
  }
  if(Array.isArray(v?.option_values)){
    const vals=v.option_values.map(x=>typeof x==='object'?(x?.value??x?.name):x).filter(Boolean);
    if(vals.length)return vals;
  }
  if(v?.option_values&&typeof v.option_values==='object'){
    const vals=Object.values(v.option_values).map(x=>typeof x==='object'?(x?.value??x?.name):x).filter(Boolean);
    if(vals.length)return vals;
  }
  if(Array.isArray(v?.options)){
    const vals=v.options.map(x=>typeof x==='object'?(x?.value??x?.name):x).filter(Boolean);
    if(vals.length)return vals;
  }
  const positional=[v?.option1,v?.option2,v?.option3].filter(Boolean);
  return positional;
};
const variantLabel=v=>{
  const sourceOptions=optionValuesOf(v).map(x=>String(x).replace(/_/g,' ').trim()).filter(Boolean);
  if(sourceOptions.length)return sourceOptions.join(' · ');
  const raw=[v?.language,v?.edition,v?.rarity,v?.finish?finishLabel(v.finish):(v?.treatment||v?.variant),v?.condition]
    .map(x=>String(x||'').trim()).filter(Boolean);
  const seen=new Set();
  return raw.filter(x=>{const k=norm(x);if(seen.has(k))return false;seen.add(k);return true}).join(' · ');
};

// BURRO_V40D2_YGO_GROUPING
// YGO browser identity: one visible card per set + collector number + card.
// Rarity/edition/language remain options; provider IDs are never Burro identity.
const ygoCollectorNorm=v=>String(v||'').replace(/\s+/g,'').toUpperCase();
const ygoEditionValues=c=>{
  const out=[];
  const push=v=>{
    if(Array.isArray(v)){v.forEach(push);return;}
    if(v&&typeof v==='object'){Object.keys(v).forEach(push);return;}
    const raw=String(v||'').trim();
    if(!raw)return;
    const n=norm(raw).replace(/[\s_-]+/g,'');
    let shown=raw;
    if(n==='1st'||n==='1stedition'||n==='first'||n==='firstedition')shown='1st';
    else if(n==='unlimited'||n==='unlimitededition')shown='Unlimited';
    else if(n==='limited'||n==='limitededition')shown='Limited';
    if(!out.some(x=>norm(x)===norm(shown)))out.push(shown);
  };
  push(c?.editions);
  push(c?.metadata?.editions);
  push(c?.edition_labels);
  return out;
};
const ygoLanguageValues=c=>{
  const vals=[];
  const push=v=>{
    if(Array.isArray(v)){v.forEach(push);return;}
    const raw=String(v||'').trim(); if(!raw)return;
    const shown=raw.toLowerCase()==='en'?'EN':raw.toLowerCase()==='es'?'ES':raw.toUpperCase();
    if(!vals.includes(shown))vals.push(shown);
  };
  push(c?.languages); push(c?.language); push(c?.metadata?.language);
  return vals.length?vals:['EN'];
};
const ygoCanonicalBrowserName=c=>{
  const sc=setCode(c), cn=ygoCollectorNorm(collector(c));
  if(sc==='TKN4'&&cn==='TKN4-EN033')return 'Token (Yusaku)';
  return String(c?.name||'').trim();
};
const ygoQuarantinedBrowserRecord=c=>{
  if(setCode(c)!=='DUOV'||ygoCollectorNorm(collector(c))!=='DUOV-EN100')return false;
  const n=norm(c?.name||'');
  return n===norm('Cyber Dragon Infinity')||n===norm('Tour Guide From the Underworld');
};
const rarityValues=c=>{
  const vals=Array.isArray(c?.rarities)?c.rarities:[c?.rarity];
  return [...new Set(vals.map(x=>String(x||'').trim()).filter(Boolean))];
};
const displayRarities=c=>{
  const vals=rarityValues(c);
  return vals.length?vals.map(titleCase).join(' / '):'—';
};
const groupYgoRows=(input,game)=>{
  const rows=Array.isArray(input)?input:[];
  if(String(game||'').trim().toLowerCase()!=='ygo')return rows;
  const map=new Map();

  rows.forEach(card=>{
    if(!card||ygoQuarantinedBrowserRecord(card))return;
    const sc=setCode(card);
    const cn=ygoCollectorNorm(collector(card));
    const canonical=ygoCanonicalBrowserName(card);
    if(!sc||!cn||!canonical)return;

    const key=`${sc}|${cn}|${norm(canonical)}`;
    let group=map.get(key);
    if(!group){
      const rep={...card};
      rep.name=canonical;
      rep.rarities=[];
      rep.editions=[];
      rep.languages=[];
      rep._ygo_grouped=true;
      rep._ygo_grouped_count=0;
      rep._ygo_source_names=[];
      map.set(key,rep);
      group=rep;
    }

    group._ygo_grouped_count+=1;
    const sourceName=String(card?.name||'').trim();
    if(sourceName&&!group._ygo_source_names.includes(sourceName))group._ygo_source_names.push(sourceName);

    rarityValues(card).forEach(v=>{if(!group.rarities.some(x=>norm(x)===norm(v)))group.rarities.push(v)});
    ygoEditionValues(card).forEach(v=>{if(!group.editions.some(x=>norm(x)===norm(v)))group.editions.push(v)});
    ygoLanguageValues(card).forEach(v=>{if(!group.languages.includes(v))group.languages.push(v)});

    if(!group._commerce&&card?._commerce)group._commerce=card._commerce;
    if(!frontImage(group)&&frontImage(card)){
      if(card.image)group.image=card.image;
      if(card.image_uris)group.image_uris=card.image_uris;
      if(card.card_faces)group.card_faces=card.card_faces;
    }
  });

  return [...map.values()];
};
// /BURRO_V40D2_YGO_GROUPING

const productNameHtml=c=>{
  const name=esc(c?.name||'Sin nombre');
  const url=productUrlOf(c);
  return url?`<a class="btcg-card__product-link" href="${esc(url)}">${name}</a>`:name;
};

document.querySelectorAll('[data-btcg-root]').forEach(init);

function init(root){
  const base=String(root.dataset.catalogBase||'').replace(/\/+$/,'');
  const state={
    game:'',gameName:'',mode:'cards',setCode:'',setsByGame:{},cards:[],
    setsStockOnly:false,setStockByGame:{},setStockPending:{},setStockErrors:{},group:'year',letter:'',setType:'all',sort:'collector_asc',facets:{},stockOnly:false,searchFacets:{},searchStockOnly:false,searchExecuted:false,lastSearchTerm:'',searchTimer:null,placeholderTimer:null,
    examples:[],searchResults:[],lightbox:null,commerceBySet:{},collectionManifest:null
  };

  const views={home:q(root,'[data-btcg-view="home"]'),game:q(root,'[data-btcg-view="game"]'),set:q(root,'[data-btcg-view="set"]')};
  const panels={cards:q(root,'[data-btcg-panel="cards"]'),sets:q(root,'[data-btcg-panel="sets"]')};
  const collectionHandle=String(root.dataset.collectionHandle||'').trim().toLowerCase();
  const search=q(root,'[data-btcg-search]');
  const suggestions=q(root,'[data-btcg-suggestions]');
  const setSearch=q(root,'[data-btcg-set-search]');

  // V47B_ADVANCED_CSS_GUARD
  if(!document.getElementById('btcg-v47b-ui-style')){
    const s=document.createElement('style');
    s.id='btcg-v47b-ui-style';
    s.textContent='.btcg-advanced-search{display:none!important}[data-group="year"][hidden]{display:none!important}';
    document.head.appendChild(s);
  }

  if(!document.getElementById('btcg-commerce-066-style')){
    const style=document.createElement('style');
    style.id='btcg-commerce-066-style';
    style.textContent=`
      .btcg-card__product-link{color:inherit;text-decoration:underline;text-decoration-thickness:1px;text-underline-offset:2px}
      .btcg-card__product-link:hover{text-decoration-thickness:2px}
      .btcg-card__set-link{color:inherit;text-decoration:underline;text-decoration-thickness:1px;text-underline-offset:2px}
      .btcg-card__product-cta{display:inline-flex;align-items:center;justify-content:center;min-height:36px;padding:0 12px;border:1px solid currentColor;border-radius:8px;text-decoration:none}
      .btcg-card__commerce select,.btcg-card__commerce input{font:inherit;border:1px solid rgba(0,0,0,.18);border-radius:7px;background:#fff;color:inherit;padding:6px 8px}
      .btcg-card__commerce [data-commerce-add]{min-height:36px}
      .btcg-card__commerce [data-commerce-price]{font-weight:900;color:#123f6f;font-size:1.05rem}
      /* 063: comercio utilizable tanto en lista como en cuadrícula. */
      .btcg__search-results.is-list .btcg-card__commerce{display:block!important;padding-left:16px;border-left:1px solid var(--burro-line,#ddd)}
      .btcg__search-results.is-list .btcg-card__body{grid-template-columns:minmax(0,1fr) 280px!important}
      .btcg__search-results.is-list .btcg-card__availability span{display:none}
      .btcg__search-results:not(.is-list) .btcg-card__commerce,.btcg__cards:not(.is-list) .btcg-card__commerce{display:block!important;margin-top:10px;width:100%}
      .btcg__search-results:not(.is-list) .btcg-card__body,.btcg__cards:not(.is-list) .btcg-card__body{display:block!important}
      .btcg__search-results:not(.is-list) .btcg-card__availability span,.btcg__cards:not(.is-list) .btcg-card__availability span{display:none}
      .btcg-commerce-variant select{width:100%}
      .btcg-commerce-actions [data-commerce-add]{flex:1}
      /* Una carta sin reverso físico nunca debe enseñar control de giro, incluso si el theme intenta sobrescribir hidden. */
      .btcg-lightbox__flip[hidden],.btcg-card__flip-inline[hidden]{display:none!important}
      /* 068K — cierre unificado: misma X hand-drawn de Burro, amarillo + azul,
         con el mismo pequeño movimiento del botón de búsqueda. */
      .btcg-lightbox__close{
        background:var(--burro-yellow,#f4bd00)!important;
        color:var(--burro-blue,#17385f)!important;
        display:grid!important;
        place-items:center!important;
        transition:transform .15s ease,background-color .15s ease,color .15s ease!important;
      }
      .btcg-lightbox__close .btcg-hand-x{
        width:25px!important;
        height:21px!important;
        color:currentColor!important;
        transition:transform .15s ease!important;
      }
      .btcg-lightbox__close:hover{
        background:var(--burro-yellow,#f4bd00)!important;
        color:var(--burro-blue,#17385f)!important;
        transform:translateY(-2px);
      }
      .btcg-lightbox__close:hover .btcg-hand-x{
        transform:rotate(1deg) scale(1.04)!important;
      }
      .btcg-lightbox__close:active{
        transform:translateY(0);
      }
      .btcg-lightbox__close:active .btcg-hand-x{
        transform:rotate(-3deg) scale(.98)!important;
      }
      /* 068K — misma señal visual que product page:
         la lupa con “−” es SOLO el cursor de cerrar la imagen ampliada. */
      [data-btcg-lightbox-image]{
        cursor:zoom-out!important;
        width:min(78vw,520px)!important;
        height:auto!important;
        max-width:min(78vw,520px)!important;
        max-height:78vh!important;
        object-fit:contain!important;
      }
      /* 068K — +/- de acordeones con trazo manual sutil, consistente con las flechas Burro. */
      .btcg-filter-group__toggle::before,.btcg-filter-group__toggle::after{display:none!important}
      .btcg-filter-group__toggle{width:26px!important;height:24px!important;display:grid!important;place-items:center!important;flex:0 0 26px!important}
      .btcg-filter-hand-sign{width:28px;height:26px;display:block;overflow:visible;transform:rotate(-1.5deg)}
      .btcg-filter-hand-sign path{fill:none;stroke:var(--burro-blue,#17385f);stroke-linecap:round;stroke-linejoin:round;vector-effect:non-scaling-stroke}
      .btcg-filter-hand-sign .main{stroke-width:2.6}
      .btcg-filter-hand-sign .dry{stroke-width:1.05;opacity:.5}
      .btcg-filter-hand-sign .ghost{stroke-width:.75;opacity:.28}
      .btcg-filter-hand-sign--minus{display:none!important}
      .btcg-filter-group[open] .btcg-filter-hand-sign--plus{display:none!important}
      .btcg-filter-group[open] .btcg-filter-hand-sign--minus{display:block!important}
      .btcg-mobile-filter-toggle{display:none}
      @media(max-width:760px){
        .btcg-mobile-filter-toggle{display:inline-flex!important;align-items:center;gap:6px;border:1px solid var(--burro-line,#ddd);background:#fff;border-radius:999px;padding:7px 10px;font-weight:800;color:var(--burro-navy,#17385f);cursor:pointer}
        .btcg-filters.is-mobile-collapsed>:not(.btcg-filters__head){display:none!important}
        .btcg-filters.is-mobile-collapsed{padding-bottom:8px!important}
      }
      @media(max-width:989px){
        .btcg__search-results.is-list .btcg-card__body{grid-template-columns:1fr!important}
        .btcg__search-results.is-list .btcg-card__commerce{border-left:0;padding-left:0;border-top:1px solid var(--burro-line,#ddd);padding-top:10px;margin-top:10px}
      }
    `;
    document.head.appendChild(style);
  }

  function seoSlug(value){
    return String(value||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'');
  }

  function gameCollectionUrl(){ return dynamicGameUrl('cards'); }
  function setCollectionUrlByName(setName){ return dynamicGameUrl('sets'); }

  async function loadCollectionManifest(forceGame=''){
    const game=(forceGame||state.game||'').trim();
    if(!game)return {};
    if(state.collectionManifest && game===state.game)return state.collectionManifest;
    try{
      const payload=await getJson(`commerce/${game}/collections.json`);
      if(game===state.game)state.collectionManifest=payload;
      return payload||{};
    }catch(e){
      if(game===state.game)state.collectionManifest={};
      return {};
    }
  }
  function knownGameCollection(){ return ''; }
  function knownSetCollection(code){ return ''; }
  // V48_GAME_BUTTON_LOOKUP
  function gameButtonFor(canonical){
    return qa(root,'[data-game]').find(btn=>gameKey(btn.dataset.game)===gameKey(canonical))||null;
  }

  function dynamicGameUrl(mode='cards'){
    return `/pages/tcg-singles?game=${encodeURIComponent(state.game)}&mode=${encodeURIComponent(mode)}`;
  }
  function dynamicSetUrl(code){
    return `/pages/tcg-singles?game=${encodeURIComponent(state.game)}&mode=sets&set=${encodeURIComponent(String(code||'').toUpperCase())}`;
  }
  function isCurrentGameCollection(){
    const clean=knownGameCollection();
    return Boolean(clean && location.pathname===new URL(clean,location.origin).pathname);
  }
  async function deriveCollectionContext(){
    const metaGame=gameKey(root.dataset.collectionGame||'');
    const metaSet=String(root.dataset.collectionSet||'').toUpperCase();
    if(metaGame)return {game:metaGame,set:metaSet};
    if(!collectionHandle)return {game:'',set:''};

    const gameButtons=qa(root,'[data-game]');
    for(const btn of gameButtons){
      const candidate=gameKey(btn.dataset.game);
      if(collectionHandle===`${seoSlug(candidate)}-singles`){
        return {game:candidate,set:''};
      }
    }
    for(const btn of gameButtons){
      const candidate=gameKey(btn.dataset.game);
      if(!collectionHandle.startsWith(`${seoSlug(candidate)}-`))continue;
      const manifest=await loadCollectionManifest(candidate);
      for(const [code,info] of Object.entries(manifest?.sets||{})){
        const handle=String(info?.handle||String(info?.url||'').split('/').filter(Boolean).pop()||'').toLowerCase();
        if(handle===collectionHandle)return {game:candidate,set:String(code).toUpperCase()};
      }
    }
    return {game:'',set:''};
  }
  function renderGameHeading(){
    const el=q(root,'[data-btcg-game-title]'); if(!el)return;
    el.innerHTML=`<a class="btcg-card__product-link" href="${esc(dynamicGameUrl(state.mode||'cards'))}">${esc(state.gameName||state.game)}</a>`;
  }

  // V48_PRESENTATION_HELPERS
  function setMetaByTechnicalCode(code){
    const wanted=String(code||'').toUpperCase();
    return currentSets().find(s=>String(s?.code||'').toUpperCase()===wanted || (Array.isArray(s?.member_codes)&&s.member_codes.map(x=>String(x).toUpperCase()).includes(wanted)))||{};
  }
  function gameAcronym(){return ({mtg:'MTG',pokemon:'PKM',ygo:'YGO',onepiece:'OP',riftbound:'RIFT',fab:'FAB',lorcana:'LOR',digimon:'DIGI',swu:'SWU',gundam:'GUNDAM',dbfw:'DBFW',dbm:'DBS'})[state.game]||String(state.game||'TCG').slice(0,6).toUpperCase();}
  function cleanCollectorDisplay(c){let n=collector(c);if(state.game==='digimon')n=n.replace(/\s+(?:C|U|UC|R|SR|SEC|PR|P|SP)$/i,'');return n;}
  function cardReferenceHtml(c,code,{search=false}={}){
    const technical=String(code||setCode(c)||'').toUpperCase(),meta=setMetaByTechnicalCode(technical),nice=displaySetCode(meta),num=cleanCollectorDisplay(c);
    const label=search?(nice||String(meta?.name||c?.set_name||c?.setName||'').trim()):nice;
    const setPart=label?`<a class="btcg-card__set-link" href="${esc(dynamicSetUrl(String(meta?.code||technical)))}">${esc(label)}</a>`:'';
    return [setPart,num?`#${esc(num)}`:''].filter(Boolean).join(' · ');
  }
  function hiResImageUrl(url){const u=String(url||'');return /product-images\.tcgplayer\.com/i.test(u)?u.replace(/\/fit-in\/\d+x\d+\//i,'/fit-in/1000x1000/'):u;}

  function setCollectionHtml(c,code){ return cardReferenceHtml(c,code,{search:true}); }

  async function getJson(path){
    const cleanPath=String(path).replace(/^\/+/, '');
    const origin=cleanPath.startsWith('catalog/') ? stockIndexOrigin : base;
    const r=await fetch(origin+'/'+cleanPath,{headers:{Accept:'application/json'},cache:'no-cache'});
    if(!r.ok)throw new Error('HTTP '+r.status);
    return r.json();
  }

  // Availability is read from Engine's current commerce snapshots, not the static catalog.
  const stockIndexOrigin=String(root.dataset.commerceBase||'https://burro-engine-production.up.railway.app').replace(/\/+$/,'');
  async function loadSetStock(){
    const game=state.game;
    if(state.setStockPending[game])return state.setStockPending[game];
    state.setStockErrors[game]='';
    const request=(async()=>{
      try{
        const response=await fetch(`${stockIndexOrigin}/commerce/${encodeURIComponent(game)}/sets.json`,{cache:'no-store',signal:AbortSignal.timeout(15000)});
        if(!response.ok)throw new Error('HTTP '+response.status);
        const payload=await response.json();
        if(gameKey(payload.game)!==game||payload.source!=='shopify'||!Array.isArray(payload.sets))throw new Error('Invalid stock index');
        state.setStockByGame[game]=new Set(payload.sets.filter(s=>s.in_stock===true).map(s=>String(s.code).toUpperCase()));
      }catch(error){
        delete state.setStockByGame[game];
        state.setStockErrors[game]='No pudimos consultar el stock. Intenta de nuevo.';
      }finally{
        delete state.setStockPending[game];
        if(state.game===game){populateYears();renderModeControls();renderSets();}
      }
    })();
    state.setStockPending[game]=request;
    return request;
  }
  function passesSetStock(s){
    if(!state.setsStockOnly)return true;
    const available=state.setStockByGame[state.game];
    const codes=[s.code,s.set_code,...(Array.isArray(s.member_codes)?s.member_codes:[])];
    return Boolean(available&&codes.some(code=>available.has(String(code||'').toUpperCase())));
  }
  const setsStockCheckbox=q(root,'[data-btcg-sets-stock-only]');
  setsStockCheckbox?.addEventListener('change',()=>{
    state.setsStockOnly=setsStockCheckbox.checked;
    state.letter='';
    if(state.setsStockOnly)loadSetStock();
    populateYears();renderModeControls();renderSets();
  });


  // MTG stock browsing: isolated from ordinary search and other games.
  const browse={active:false,loading:false,token:0,rows:[],page:1,size:48,observer:null,renderId:0};
  const browseButton=q(root,'[data-btcg-browse-all]');
  const browseTools=q(root,'[data-btcg-browse-tools]');
  const browsePager=q(root,'[data-btcg-browse-pager]');
  const browseLoading=q(root,'[data-browse-loading]');
  function browseProgress(done,total){
    if(!browseLoading)return;
    browseLoading.hidden=false;
    const label=q(browseLoading,'[data-browse-progress-label]');
    const bar=q(browseLoading,'[role="progressbar"]');
    label.textContent=total?`Cargando cartas disponibles… ${done} de ${total} expansiones`:'Revisando binders, cajas y más…';
    bar.classList.toggle('is-indeterminate',!total);
    if(total){bar.setAttribute('aria-valuenow',String(Math.round(done/total*100)));}
    else bar.removeAttribute('aria-valuenow');
    q(bar,'[data-browse-progress-fill]').style.width=total?`${done/total*100}%`:'32%';
  }
  function stopBrowse(){
    browse.loading=false;browse.observer?.disconnect();
    if(browseLoading)browseLoading.hidden=true;
    browse.active=false; browse.token++; browse.rows=[]; browse.page=1;
    qa(root,'[data-browse-min],[data-browse-max]').forEach(el=>el.value='');
    const order=q(root,'[data-browse-order]');if(order)order.value='name';
    const colorMode=q(root,'[data-browse-color-mode]');if(colorMode)colorMode.value='contains';
    if(browseButton){browseButton.disabled=false;browseButton.textContent='Ver todas las cartas disponibles';}
    if(browseTools)browseTools.hidden=true;
    if(browsePager)browsePager.hidden=true;
  }
  async function browseJson(origin,path){
    const response=await fetch(origin+'/'+path,{cache:'no-store',signal:AbortSignal.timeout(45000)});
    if(!response.ok)throw new Error('HTTP '+response.status);
    return response.json();
  }
  function browseVariants(card){
    return liveVariantsOf(card).filter(v=>v.in_stock!==false &&
      (!(state.searchFacets.language||[]).length||(state.searchFacets.language||[]).includes(String(v.language))) &&
      (!(state.searchFacets.finishes||[]).length||(state.searchFacets.finishes||[]).includes(String(v.finish))));
  }
  function browsePrice(card){
    const prices=browseVariants(card).map(v=>Number(v.price)).filter(Number.isFinite);
    return prices.length?Math.min(...prices):Infinity;
  }
  function renderBrowseResults(append=false){
    if(!browse.active||browse.loading)return;
    browse.observer?.disconnect();
    const renderId=++browse.renderId;
    browseTools.hidden=false;
    const term=norm(search.value);
    const min=q(root,'[data-browse-min]').value;
    const max=q(root,'[data-browse-max]').value;
    const order=q(root,'[data-browse-order]').value;
    const rows=browse.rows.filter(c=>norm(c.name).includes(term)&&passesSearchFacets(c)&&browseVariants(c).length&&
      (min===''||browsePrice(c)>=Number(min))&&(max===''||browsePrice(c)<=Number(max)));
    rows.sort((a,b)=>(order==='price_asc'?browsePrice(a)-browsePrice(b):order==='price_desc'?browsePrice(b)-browsePrice(a):0)||String(a.name).localeCompare(String(b.name),'es')||setCode(a).localeCompare(setCode(b))||collector(a).localeCompare(collector(b),undefined,{numeric:true}));
    const end=Math.min(browse.page*browse.size,rows.length);
    const start=append?(browse.page-1)*browse.size:0;
    const visible=rows.slice(start,end).map(c=>({...c,_commerce:{...c._commerce,variants:browseVariants(c).slice().sort((a,b)=>Number(a.price)-Number(b.price)),min_price:browsePrice(c)}}));
    q(root,'[data-btcg-result-title]').textContent='Cartas MTG disponibles';
    q(root,'[data-btcg-result-count]').textContent=`${end} de ${rows.length} impresiones`;
    renderSearchActiveFilters();
    const host=q(root,'[data-btcg-search-results]');
    if(!append)host.innerHTML='';
    if(visible.length){
      const batch=document.createElement('div');
      batch.innerHTML=visible.map(searchPrintingHtml).join('');
      attachCardZoom(batch,visible);
      host.append(...Array.from(batch.children));
    }else if(!append){host.innerHTML='<div class="btcg__empty-state"><strong>No hay cartas disponibles con estos filtros.</strong></div>';}
    browsePager.hidden=false;
    if(end>=rows.length){browsePager.innerHTML=rows.length?'<span>Ya viste todas las cartas con estos filtros.</span>':'';return;}
    browsePager.innerHTML='<button type="button" class="btcg-browse-hand" data-browse-more>Cargar más cartas</button>';
    const token=browse.token;
    let used=false;
    const more=()=>{if(used||!browse.active||browse.loading||browse.token!==token||browse.renderId!==renderId)return;used=true;browse.page++;renderBrowseResults(true);};
    q(browsePager,'[data-browse-more]').onclick=more;
    if('IntersectionObserver' in window){
      browse.observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting))more();},{rootMargin:'250px'});
      browse.observer.observe(browsePager);
    }
  }
  async function startBrowse(){
    if(state.game!=='mtg'||state.mode!=='cards')return;
    resetGlobalSearch();
    browse.active=true;browse.loading=true;
    browseProgress(0,0);
    const token=++browse.token;
    const current=()=>browse.active&&browse.token===token&&state.game==='mtg'&&state.mode==='cards';
    browseButton.disabled=true;
    browseButton.textContent='Consultando disponibilidad…';
    q(root,'[data-btcg-search-catalog]').hidden=true;
    q(root,'[data-btcg-result-title]').textContent='Cartas MTG disponibles';
    const status=q(root,'[data-btcg-search-status]');
    status.textContent='Consultando inventario de Shopify…';
    try{
      const index=await browseJson(stockIndexOrigin,'commerce/mtg/sets.json');
      if(!current())return;
      if(index.source!=='shopify'||index.game!=='mtg'||!Array.isArray(index.sets))throw new Error('Invalid index');
      const codes=[...new Set(index.sets.filter(s=>s.in_stock===true).map(s=>String(s.code).toLowerCase()))];
      browseProgress(0,codes.length);
      const rows=[]; let next=0,done=0;
      await Promise.all(Array.from({length:Math.min(4,codes.length)},async()=>{
        while(next<codes.length&&current()){
          const code=codes[next++];
          const [catalog,stock]=await Promise.all([
            browseJson(stockIndexOrigin,`catalog/mtg/sets/set-${encodeURIComponent(code)}.json`),
            browseJson(stockIndexOrigin,`commerce/mtg/sets/set-${encodeURIComponent(code)}.json`)
          ]);
          if(!current())return;
          if(stock.source!=='shopify'||stock.game!=='mtg'||String(stock.set_code).toLowerCase()!==code||!Array.isArray(stock.products))throw new Error('Invalid stock');
          const metadata=new Map();
          arr(catalog).forEach(c=>{const key=collector(c).trim().toLowerCase();if(!metadata.has(key)||String(c.language).toLowerCase()==='en')metadata.set(key,c);});
          const groups=new Map();
          stock.products.forEach(p=>{
            const variants=(p.variants||[]).filter(v=>v.in_stock===true&&Number(v.inventory)>0&&shopifyVariantId(v));
            if(!variants.length)return;
            const key=String(p.collector_number||'').trim().toLowerCase();
            const meta=metadata.get(key);
            if(!meta)throw new Error('Missing catalog metadata '+code+' '+key);
            const previous=groups.get(key);
            if(previous){previous._commerce.variants.push(...variants);return;}
            groups.set(key,{...meta,name:meta.name||p.card_name,set_code:stock.set_code,_commerce:{...p,variants}});
          });
          groups.forEach(c=>{
            const seen=new Set();
            const variants=c._commerce.variants.filter(v=>{const id=shopifyVariantId(v);if(seen.has(id))return false;seen.add(id);return true;});
            c._commerce={...c._commerce,variants,in_stock:true,inventory:variants.reduce((n,v)=>n+Number(v.inventory),0),min_price:Math.min(...variants.map(v=>Number(v.price)))};
            c.language=[...new Set(variants.map(v=>String(v.language)))];
            c.finishes=[...new Set(variants.map(v=>String(v.finish)))];
            rows.push(c);
          });
          done++;browseProgress(done,codes.length);
        }
      }));
      if(!current())return;
      browse.loading=false;browseLoading.hidden=true;
      q(root,'[data-btcg-search-catalog]').hidden=false;
      browse.rows=rows;state.searchResults=rows;state.searchExecuted=false;
      browseTools.hidden=false;
      renderSearchFilters();renderBrowseResults();
      status.textContent='';
      browseButton.textContent='Actualizar cartas disponibles';
    }catch(error){
      if(!current())return;
      browse.loading=false;browseLoading.hidden=true;
      q(root,'[data-btcg-search-catalog]').hidden=false;
      browse.token++;browse.rows=[];state.searchResults=[];
      q(root,'[data-btcg-search-results]').innerHTML='';
      status.textContent='No pudimos completar la consulta. Presioná “Reintentar” para cargar todas las cartas; no mostramos un catálogo parcial.';
      browseButton.textContent='Reintentar';
      console.warn('[MTG available cards]',error);
    }finally{if(browse.active&&state.game==='mtg')browseButton.disabled=false;}
  }
  browseButton?.addEventListener('click',startBrowse);
  q(root,'[data-btcg-search-clear-filters]')?.addEventListener('click',()=>{qa(root,'[data-browse-min],[data-browse-max]').forEach(el=>el.value='');q(root,'[data-browse-color-mode]').value='contains';});
  qa(root,'[data-browse-min],[data-browse-max],[data-browse-order],[data-browse-color-mode]').forEach(el=>el.addEventListener('input',()=>{browse.page=1;renderBrowseResults();}));
  q(root,'[data-browse-exit]')?.addEventListener('click',resetGlobalSearch);

  function resolveCommercePrinting(card, candidates, game){
    const products=Array.isArray(candidates)?candidates:[];
    if(game!=='fab')return products[products.length-1]||null;
    const normalize=value=>String(value||'').normalize('NFKC').toLowerCase().replace(/[^\p{L}\p{N}]+/gu,' ').trim();
    const name=normalize(card.name);
    const matches=products.filter(p=>normalize(p.card_name)===name);
    if(matches.length!==1)return null;
    const finishKey=value=>String(value||'').toLowerCase().replace(/[^a-z0-9]/g,'');
    const finishes=new Set((card.finishes||card.treatments||[]).map(finishKey));
    const marvel=/\bmarvel\b/.test(name);
    const variants=(matches[0].variants||[]).filter(v=>{
      const finish=finishKey(v.finish);
      return finishes.has(finish)&&(!marvel||!['regular','nonfoil','normal'].includes(finish));
    });
    if(!variants.length)return null;
    const available=variants.filter(v=>Number(v.inventory)>0&&v.in_stock!==false);
    const inventory=available.reduce((sum,v)=>sum+Number(v.inventory),0);
    const prices=available.map(v=>Number(v.price)).filter(Number.isFinite);
    return {...matches[0],variants,inventory,in_stock:inventory>0,
      available_variants:available.length,min_price:prices.length?Math.min(...prices):null};
  }

  async function loadCommerceSet(code){
    code=String(code||'').trim().toUpperCase();
    if(!code)return new Map();
    if(state.commerceBySet[code])return state.commerceBySet[code];
    const map=new Map();
    try{
      const payload=await getJson(`commerce/${state.game}/sets/set-${code.toLowerCase()}.json`);
      const products=Array.isArray(payload?.products)?payload.products:[];
      products.forEach(p=>{
        const key=String(p.collector_number||'').trim().toLowerCase();
        if(key)map.set(key,[...(map.get(key)||[]),p]);
      });
    }catch(e){
      if(!String(e?.message||'').includes('HTTP 404'))console.warn('[TCG Singles commerce]',state.game,code,e);
    }
    state.commerceBySet[code]=map;
    return map;
  }

  async function enrichWithCommerce(rows){
    const list=Array.isArray(rows)?rows:[];
    const codes=[...new Set(list.map(setCode).filter(Boolean))];
    await Promise.all(codes.map(loadCommerceSet));
    list.forEach(c=>{
      const code=setCode(c);
      const key=collector(c).trim().toLowerCase();
      c._commerce=resolveCommercePrinting(c,state.commerceBySet[code]?.get(key),state.game);
    });
    return list;
  }

  function show(name){
    Object.entries(views).forEach(([k,v])=>v.hidden=k!==name);
    // Always restore the storefront header instead of jumping the browser down
    window.scrollTo({top:0,left:0,behavior:'auto'});
  }

  function setUrl(next,replace=false){
    const u=new URL(location.href);
    ['game','mode','set'].forEach(k=>next[k]?u.searchParams.set(k,next[k]):u.searchParams.delete(k));
    history[replace?'replaceState':'pushState']({},'',u);
  }

  function resetGlobalSearch(){
    stopBrowse();
    search.value='';
    suggestions.hidden=true;
    suggestions.innerHTML='';
    state.searchResults=[];
    state.searchFacets={};
    state.searchStockOnly=false;
    state.searchExecuted=false;
    state.lastSearchTerm='';
    q(root,'[data-btcg-search-stock-only]').checked=false;
    q(root,'[data-btcg-search-catalog]').hidden=true;
    q(root,'[data-btcg-result-title]').textContent='';
    q(root,'[data-btcg-result-count]').textContent='';
    q(root,'[data-btcg-search-active-filters]').innerHTML='';
    q(root,'[data-btcg-search-results]').innerHTML='';
    q(root,'[data-btcg-search-status]').textContent='';
    renderSearchAction();
  }

  function resetSetState(){
    setSearch.value='';
    q(root,'[data-btcg-set-clear]').hidden=true;
    state.facets={};state.stockOnly=false;state.letter='';state.setCode='';state.sort='collector_asc';
    q(root,'[data-btcg-stock-only]').checked=false;
    const sort=q(root,'[data-btcg-sort]'); if(sort)sort.value='collector_asc';
    q(root,'[data-btcg-active-filters]').innerHTML='';
  }

  function resetAllTransient(){
    resetGlobalSearch();
    resetSetState();
  }

  const handArrowSvg=()=>'<svg class="btcg-hand-arrow" viewBox="0 0 76 48" aria-hidden="true"><path class="btcg-hand-arrow__brush btcg-hand-arrow__shaft" d="M10 25 C24 23 39 24 56 23"/><path class="btcg-hand-arrow__brush btcg-hand-arrow__head" d="M47 12 C52 16 57 20 63 23"/><path class="btcg-hand-arrow__brush btcg-hand-arrow__head" d="M63 23 C57 28 52 33 47 38"/><path class="btcg-hand-arrow__dry" d="M12 28 C29 25 43 27 56 25"/><path class="btcg-hand-arrow__dry" d="M49 14 C54 18 58 21 61 23"/></svg>';
  const handXSvg=()=>'<svg class="btcg-hand-x" viewBox="0 0 70 48" aria-hidden="true"><path class="btcg-hand-x__brush" d="M13 8 C20 15 27 21 34 28 C41 34 48 39 57 43"/><path class="btcg-hand-x__brush btcg-hand-x__brush--b" d="M57 7 C49 14 42 20 35 27 C28 34 21 39 12 43"/><path class="btcg-hand-x__dry" d="M16 10 C23 16 30 22 36 28 C43 34 49 38 54 40"/><path class="btcg-hand-x__dry" d="M54 9 C47 15 40 21 34 27 C27 34 21 38 15 41"/></svg>';
const handRotateSvg=()=>'<svg class="btcg-hand-swap" viewBox="0 0 76 54" aria-hidden="true"><path class="btcg-hand-swap__brush btcg-hand-swap__top" d="M12 18 C24 17 38 18 54 17"/><path class="btcg-hand-swap__brush btcg-hand-swap__head" d="M46 10 C51 13 55 15 61 17"/><path class="btcg-hand-swap__brush btcg-hand-swap__head" d="M61 17 C56 20 52 23 47 27"/><path class="btcg-hand-swap__dry" d="M14 21 C27 19 40 20 53 19"/><path class="btcg-hand-swap__brush btcg-hand-swap__bottom" d="M62 36 C49 37 36 36 20 37"/><path class="btcg-hand-swap__brush btcg-hand-swap__head" d="M29 28 C24 31 20 34 14 37"/><path class="btcg-hand-swap__brush btcg-hand-swap__head" d="M14 37 C19 40 23 43 28 46"/><path class="btcg-hand-swap__dry" d="M60 33 C48 35 35 34 22 35"/></svg>';


  function renderSetSearchAction(){
    const btn=q(root,'[data-btcg-set-clear]');
    const input=q(root,'[data-btcg-set-search]');
    if(!btn||!input)return;
    const hasText=String(input.value||'').trim().length>0;
    btn.hidden=false;
    btn.classList.toggle('is-clear',hasText);
    btn.setAttribute('aria-label',hasText?'Limpiar búsqueda':'Buscar');
    btn.innerHTML=hasText?handXSvg():handArrowSvg();
  }

  function renderSearchAction(){
    const btn=q(root,'[data-btcg-search-submit]');
    if(!btn)return;

    const hasText=String(search?.value||'').trim().length>0;
    const shouldClear=
      (state.mode==='cards' && state.searchExecuted) ||
      (state.mode==='sets' && hasText);

    if(shouldClear){
      btn.classList.add('is-clear');
      btn.setAttribute('aria-label','Limpiar búsqueda');
      btn.innerHTML=handXSvg();
      return;
    }

    btn.classList.remove('is-clear');
    btn.setAttribute('aria-label','Buscar');
    btn.innerHTML=handArrowSvg();
  }

  function rotatePlaceholder(){
    clearInterval(state.placeholderTimer);
    let i=-1;
    const baseText=state.mode==='sets'?'Encuentra una expansión…':'Busca algo increíble…';
    search.placeholder=baseText;
    if(!state.examples.length)return;
    state.placeholderTimer=setInterval(()=>{
      if(search.value||document.activeElement===search)return;
      i=(i+1)%state.examples.length;
      search.placeholder=i<0?baseText:`Prueba “${state.examples[i]}”`;
    },2600);
  }


  /* 068K — Registro visual automático de juegos publicados.
     La complejidad queda detrás: si el catálogo existe pero el Liquid todavía
     no trae la tarjeta, clonamos una tarjeta existente para mantener EXACTAMENTE
     el estilo del theme. Esta base se reutiliza para futuros TCG. */
  function ensurePublishedGameButton(def){
    if(!def?.key || q(root,`[data-game="${CSS.escape(def.key)}"]`))return;
    const template=
      q(root,'[data-game="riftbound"]')||
      q(root,'[data-game="mtg"]')||
      q(root,'[data-game]');
    if(!template)return;

    const clone=template.cloneNode(true);
    const oldGame=String(template.dataset.game||'');
    const oldName=String(template.dataset.name||oldGame||'').trim();

    clone.dataset.game=def.key;
    clone.dataset.name=def.name;
    clone.dataset.examples=(def.examples||[]).join(',');
    clone.removeAttribute('aria-current');
    clone.classList.remove('is-active');

    // Sustituye únicamente texto humano de la tarjeta clonada.
    const walker=document.createTreeWalker(clone,NodeFilter.SHOW_TEXT);
    const nodes=[];
    while(walker.nextNode())nodes.push(walker.currentNode);
    nodes.forEach(node=>{
      let text=node.nodeValue||'';
      if(oldName)text=text.split(oldName).join(def.name);
      if(oldGame && oldGame!==oldName){
        const rx=new RegExp(oldGame.replace(/[.*+?^${}()|[\]\\]/g,'\\$&'),'gi');
        text=text.replace(rx,def.name);
      }
      node.nodeValue=text;
    });

    const stats=q(clone,'[data-game-stats]') || (clone.matches?.('[data-game-stats]')?clone:null);
    if(stats){
      stats.setAttribute('data-game-stats',def.key);
      stats.textContent=def.stats||'Catálogo disponible';
    }

    // Nunca mostramos el logo equivocado de la tarjeta usada como plantilla.
    // Si el diseño tiene imagen decorativa propia del juego, la ocultamos;
    // el resto de la geometría/estilo de la tarjeta se conserva intacto.
    qa(clone,'img').forEach(img=>{
      const alt=String(img.alt||'').toLowerCase();
      if(oldName && (alt.includes(oldName.toLowerCase()) || alt.includes(oldGame.toLowerCase()))){
        img.hidden=true;
      }
    });

    const visual=q(clone,'.btcg-game__visual');
    let overlay=q(clone,'.btcg-game__name-overlay');
    if(!overlay && visual){
      overlay=document.createElement('strong');
      overlay.className='btcg-game__name-overlay btcg-game__auto-name';
      visual.appendChild(overlay);
    }
    if(overlay)overlay.textContent=def.name;

    clone.dataset.autoGame='true';
    template.parentNode?.appendChild(clone);
  }

  // V45_ALL_SUPPORTED_GAMES
  const frontendGames=[
    {key:'mtg',name:'Magic: The Gathering',examples:['The One Ring','Counterspell','Gandalf']},
    {key:'pokemon',name:'Pokémon',examples:['Pikachu','Charizard','Eevee']},
    {key:'ygo',name:'Yu-Gi-Oh!',examples:['Blue-Eyes White Dragon','Dark Magician','Ash Blossom']},
    {key:'onepiece',name:'One Piece',examples:['Monkey D. Luffy','Roronoa Zoro','Nami']},
    {key:'riftbound',name:'Riftbound',examples:['Jinx','Ahri','Yasuo']},
    {key:'fab',name:'Flesh and Blood',examples:['Bravo','Ira','Dorinthea']},
    {key:'lorcana',name:'Lorcana',examples:['Elsa','Mickey Mouse','Maleficent']},
    {key:'digimon',name:'Digimon',examples:['Agumon','Omnimon','Gabumon']},
    {key:'swu',name:'Star Wars: Unlimited',examples:['Darth Vader','Luke Skywalker','Ahsoka Tano']},
    {key:'gundam',name:'Gundam',examples:['Gundam','Gundam Aerial','Char Aznable']},
    {key:'dbfw',name:'Dragon Ball Super Fusion World',examples:['Son Goku','Vegeta','Gohan']},
    {key:'dbm',name:'Dragon Ball Super Masters',examples:['Son Goku','Vegeta','Frieza']}
  ];

  /* V46D: auto-created game cards disabled; Theme Editor remains authoritative. */


  async function hydrateFrontendGameCatalogs(){
    await Promise.allSettled(frontendGames.map(async def=>{
      const btn=q(root,`[data-game="${CSS.escape(def.key)}"]`);
      if(!btn)return;
      const stat=q(btn,'[data-game-stats]') || q(root,`[data-game-stats="${CSS.escape(def.key)}"]`);
      try{
        const payload=await getJson(`catalog/${def.key}/sets.json`);
        const rows=arr(payload);
        const count=rows.length;
        btn.dataset.catalogReady=count>0?'true':'false';
        btn.classList.toggle('is-catalog-pending',count===0);
        if(stat)stat.textContent=count?`${count} expansiones`:'Catálogo en preparación';
      }catch(e){
        btn.dataset.catalogReady='false';
        btn.classList.add('is-catalog-pending');
        if(stat)stat.textContent='Catálogo en preparación';
        console.warn('[TCG Singles catalog availability]',def.key,e);
      }
    }));
  }
  hydrateFrontendGameCatalogs();

  qa(root,'[data-game]').forEach(btn=>btn.addEventListener('click',()=>enterGame(btn)));

  q(root,'[data-btcg-back]').addEventListener('click',()=>{
    resetAllTransient();clearInterval(state.placeholderTimer);state.game='';
    if(location.pathname.startsWith('/collections/')){location.href='/pages/tcg-singles';return;}
    setUrl({});show('home');
  });

  q(root,'[data-btcg-set-back]').addEventListener('click',()=>{
    resetSetState();const url=knownGameCollection(); if(url){location.href=url;}else{setUrl({game:state.game,mode:'sets'});show('game');setMode('sets',false,true);}
  });

  qa(root,'[data-mode]').forEach(btn=>btn.addEventListener('click',()=>{
    resetAllTransient();setMode(btn.dataset.mode,true,true);
  }));

  qa(root,'[data-group]').forEach(btn=>btn.addEventListener('click',()=>{
    state.group=btn.dataset.group;state.letter='';
    qa(root,'[data-group]').forEach(x=>x.classList.toggle('is-active',x===btn));
    const year=q(root,'[data-btcg-year]'); if(year)year.value='';
    renderModeControls();renderSets();
  }));

  function initMobileFilterCollapsing(){
    qa(root,'.btcg-filters').forEach(panel=>{
      const head=q(panel,'.btcg-filters__head'); if(!head||q(head,'.btcg-mobile-filter-toggle'))return;
      const btn=document.createElement('button');
      btn.type='button'; btn.className='btcg-mobile-filter-toggle'; btn.setAttribute('aria-expanded','false'); btn.textContent='Filtros';
      head.appendChild(btn);
      const sync=()=>{
        const mobile=window.matchMedia('(max-width:760px)').matches;
        if(!mobile){panel.classList.remove('is-mobile-collapsed');btn.setAttribute('aria-expanded','true');btn.textContent='Filtros';return}
        if(!panel.dataset.mobileTouched){panel.classList.add('is-mobile-collapsed');btn.setAttribute('aria-expanded','false');btn.textContent='Filtros'}
      };
      btn.addEventListener('click',()=>{panel.dataset.mobileTouched='1';const collapsed=panel.classList.toggle('is-mobile-collapsed');btn.setAttribute('aria-expanded',collapsed?'false':'true');btn.textContent=collapsed?'Filtros':'Ocultar filtros'});
      sync(); window.addEventListener('resize',sync,{passive:true});
    });
  }

  function advancedConfigForGame(){
    const configs={
      mtg:{
        colors:[['W','Blanco'],['U','Azul'],['B','Negro'],['R','Rojo'],['G','Verde'],['C','Incoloro']],
        types:['Creature','Instant','Sorcery','Artifact','Enchantment','Land','Planeswalker','Battle']
      },
      pokemon:{
        colors:[['Grass','Planta'],['Fire','Fuego'],['Water','Agua'],['Lightning','Rayo'],['Psychic','Psíquico'],['Fighting','Lucha'],['Darkness','Oscuridad'],['Metal','Metal'],['Dragon','Dragón'],['Colorless','Incoloro']],
        types:['Pokémon','Trainer','Energy']
      },
      ygo:{colors:[],types:['Monster','Spell','Trap']},
      lorcana:{colors:[],types:['Character','Action','Item','Location']},
      onepiece:{colors:[],types:['Leader','Character','Event','Stage']},
      fab:{colors:[],types:['Attack Action','Action','Instant','Equipment','Weapon']}
    };
    return configs[state.game]||{colors:[],types:[]};
  }

  async function populateAdvancedSearchControls(){
    const panel=q(root,'[data-btcg-advanced-panel]'); if(!panel)return;
    const setSel=q(panel,'[data-advanced-set]');
    const yearSel=q(panel,'[data-advanced-year]');
    const colorSel=q(panel,'[data-advanced-color]');
    const typeInput=q(panel,'[data-advanced-type]');
    const typeList=q(panel,'[data-advanced-type-list]');
    try{
      if(!Array.isArray(state.setsByGame[state.game])){
        const payload=await getJson(`catalog/${state.game}/sets.json`);
        state.setsByGame[state.game]=arr(payload).filter(isPhysicalSet);
      }
      const sets=currentSets().filter(isPhysicalSet);
      if(setSel){
        const current=setSel.value;
        setSel.innerHTML='<option value="">Cualquier expansión</option>'+sets.slice().sort((a,b)=>String(a.name||'').localeCompare(String(b.name||''),'es')).map(s=>{
          const code=String(s.code||s.set_code||'').toUpperCase();
          return `<option value="${esc(code)}">${esc(s.name||code)}${code?' · '+esc(code):''}</option>`;
        }).join('');
        setSel.value=current;
      }
      if(yearSel){
        const current=yearSel.value;
        const years=[...new Set(sets.map(yearOf).filter(Boolean))].sort().reverse();
        yearSel.innerHTML='<option value="">Cualquier año</option>'+years.map(y=>`<option value="${esc(y)}">${esc(y)}</option>`).join('');
        yearSel.value=current;
      }
      const cfg=advancedConfigForGame();
      if(colorSel){
        colorSel.innerHTML='<option value="">Cualquier color</option>'+cfg.colors.map(([v,l])=>`<option value="${esc(v)}">${esc(l)}</option>`).join('');
        colorSel.closest('.btcg-advanced-field')?.classList.toggle('is-unavailable',!cfg.colors.length);
      }
      if(typeList)typeList.innerHTML=cfg.types.map(v=>`<option value="${esc(v)}"></option>`).join('');
      if(typeInput)typeInput.placeholder=cfg.types.length?`Ej. ${cfg.types.slice(0,3).join(', ')}`:'Escribe un tipo';
    }catch(e){
      console.warn('[TCG Singles advanced controls]',state.game,e);
    }
  }

  function initAdvancedSearch(){
    const wrap=q(root,'.btcg-search-wrap');
    if(!wrap||q(root,'[data-btcg-advanced-toggle]'))return;
    const block=document.createElement('div');
    block.className='btcg-advanced-search';
    block.innerHTML=`
      <button type="button" class="btcg-advanced-toggle" data-btcg-advanced-toggle aria-expanded="false">
        <span>Búsqueda avanzada</span><span class="btcg-advanced-toggle__mark">＋</span>
      </button>
      <div class="btcg-advanced-panel" data-btcg-advanced-panel hidden>
        <div class="btcg-advanced-grid">
          <label class="btcg-advanced-field"><span>Expansión</span><select data-advanced-set><option value="">Cualquier expansión</option></select></label>
          <label class="btcg-advanced-field"><span>Año</span><select data-advanced-year><option value="">Cualquier año</option></select></label>
          <label class="btcg-advanced-field"><span>Color</span><select data-advanced-color><option value="">Cualquier color</option></select></label>
          <label class="btcg-advanced-field"><span>Tipo</span><input data-advanced-type list="btcg-advanced-types-${esc(state.game||'game')}" autocomplete="off"><datalist id="btcg-advanced-types-${esc(state.game||'game')}" data-advanced-type-list></datalist></label>
          <label class="btcg-advanced-field btcg-advanced-field--wide"><span>Artista / ilustrador</span><input data-advanced-artist autocomplete="off" placeholder="Opcional"></label>
        </div>
        <div class="btcg-advanced-actions">
          <button type="button" class="btcg-advanced-clear" data-advanced-clear>Limpiar</button>
          <button type="button" class="btcg-advanced-run" data-advanced-run>Buscar cartas</button>
        </div>
        <p class="btcg-advanced-help">Puedes buscar sin escribir el nombre de una carta. Los resultados se afinan después con los filtros normales.</p>
      </div>`;
    wrap.insertAdjacentElement('afterend',block);

    const toggle=q(block,'[data-btcg-advanced-toggle]');
    const panel=q(block,'[data-btcg-advanced-panel]');
    toggle.addEventListener('click',async()=>{
      const open=panel.hidden;
      panel.hidden=!open;
      toggle.setAttribute('aria-expanded',open?'true':'false');
      q(toggle,'.btcg-advanced-toggle__mark').textContent=open?'−':'＋';
      if(open)await populateAdvancedSearchControls();
    });
    q(block,'[data-advanced-clear]').addEventListener('click',()=>{
      qa(block,'select').forEach(x=>x.value='');
      qa(block,'input').forEach(x=>x.value='');
    });
    q(block,'[data-advanced-run]').addEventListener('click',performAdvancedSearch);
  }

  function advancedCardMatches(c,filters){
    if(filters.color){
      const wanted=norm(filters.color);
      const vals=cardColors(c).map(v=>norm(v));
      if(!vals.includes(wanted))return false;
    }
    if(filters.type){
      const wanted=norm(filters.type);
      const vals=cardTypeValues(c).map(v=>norm(v));
      if(!vals.some(v=>v.includes(wanted)))return false;
    }
    if(filters.artist){
      const wanted=norm(filters.artist);
      if(!cardArtists(c).some(v=>norm(v).includes(wanted)))return false;
    }
    return true;
  }

  async function scanAdvancedSets(sets,filters,status){
    const out=[];
    const chunk=12;
    for(let i=0;i<sets.length;i+=chunk){
      const batch=sets.slice(i,i+chunk);
      if(status)status.textContent=`Revisando catálogo… ${Math.min(i+batch.length,sets.length)} de ${sets.length} expansiones`;
      const settled=await Promise.allSettled(batch.map(async s=>{
        const code=String(s.code||s.set_code||'').toUpperCase();
        if(!code)return[];
        const payload=await getJson(`catalog/${state.game}/sets/set-${code.toLowerCase()}.json`);
        return arr(payload).filter(c=>advancedCardMatches(c,filters));
      }));
      out.push(...settled.flatMap(x=>x.status==='fulfilled'?x.value:[]));
    }
    return out;
  }

  async function performAdvancedSearch(){
    if(browse.active)stopBrowse();
    const panel=q(root,'[data-btcg-advanced-panel]'); if(!panel)return;
    const filters={
      set:String(q(panel,'[data-advanced-set]')?.value||'').toUpperCase(),
      year:String(q(panel,'[data-advanced-year]')?.value||''),
      color:String(q(panel,'[data-advanced-color]')?.value||''),
      type:String(q(panel,'[data-advanced-type]')?.value||'').trim(),
      artist:String(q(panel,'[data-advanced-artist]')?.value||'').trim()
    };
    const term=String(search.value||'').trim();
    if(!term && !Object.values(filters).some(Boolean)){
      q(root,'[data-btcg-search-status]').textContent='Elige al menos un filtro o escribe parte del nombre de una carta.';
      return;
    }
    const status=q(root,'[data-btcg-search-status]');
    status.textContent='Preparando búsqueda avanzada…';
    suggestions.hidden=true;
    q(root,'[data-btcg-sort-wrap]')?.removeAttribute('hidden');
    try{
      let rows=[];
      if(term.length>=2){
        const matches=await searchIndexMatches(term,120);
        rows=await expandPrintings(matches,term,180);
        rows=rows.filter(c=>advancedCardMatches(c,filters));
        if(filters.set)rows=rows.filter(c=>setCode(c)===filters.set);
        if(filters.year){
          const yearSets=new Set(currentSets().filter(s=>yearOf(s)===filters.year).map(s=>String(s.code||s.set_code||'').toUpperCase()));
          rows=rows.filter(c=>yearSets.has(setCode(c)));
        }
      }else{
        if(!Array.isArray(state.setsByGame[state.game]))await populateAdvancedSearchControls();
        let sets=currentSets().filter(isPhysicalSet);
        if(filters.set)sets=sets.filter(s=>String(s.code||s.set_code||'').toUpperCase()===filters.set);
        if(filters.year)sets=sets.filter(s=>yearOf(s)===filters.year);
        rows=await scanAdvancedSets(sets,filters,status);
      }
      if(state.game==='ygo')rows=groupYgoRows(rows,state.game);
      else{
        const seen=new Set();
        rows=rows.filter(c=>{
          const k=`${setCode(c)}|${collector(c)}|${String(c.language||c.lang||'')}|${String(c.finish||c.finishes||'')}`;
          if(seen.has(k))return false; seen.add(k); return true;
        });
      }
      await enrichWithCommerce(rows);
      state.searchResults=groupYgoRows(rows,state.game);
      state.searchFacets={};
      state.searchStockOnly=false;
      state.searchExecuted=true;
      state.lastSearchTerm=term;
      const stock=q(root,'[data-btcg-search-stock-only]'); if(stock)stock.checked=false;
      q(root,'[data-btcg-search-catalog]').hidden=false;
      const labels=[];
      if(term)labels.push(`“${term}”`);
      if(filters.set)labels.push(filters.set);
      if(filters.year)labels.push(filters.year);
      if(filters.color)labels.push(formatFacetValue('colors',filters.color));
      if(filters.type)labels.push(filters.type);
      if(filters.artist)labels.push(filters.artist);
      q(root,'[data-btcg-result-title]').textContent=`Búsqueda avanzada${labels.length?' · '+labels.join(' · '):''}`;
      renderSearchAction(); renderSearchFilters(); renderSearchResults();
      status.textContent='';
      if(window.matchMedia('(max-width:760px)').matches){panel.hidden=true;q(root,'[data-btcg-advanced-toggle]')?.setAttribute('aria-expanded','false');}
    }catch(e){
      console.warn('[TCG Singles advanced search]',state.game,e);
      status.textContent='No se pudo completar la búsqueda avanzada.';
    }
  }

  // V47B_ADVANCED_SEARCH_HIDDEN
  // La implementación se conserva para retomarla después,
  // pero no se expone hasta que tenga una ventaja real frente al buscador normal.
  const staleAdvanced=q(root,'.btcg-advanced-search');
  if(staleAdvanced)staleAdvanced.remove();
  initMobileFilterCollapsing();

  search.addEventListener('input',()=>{
    if(browse.active){suggestions.hidden=true;browse.page=1;renderBrowseResults();return;}
    if(state.searchExecuted && norm(search.value)!==norm(state.lastSearchTerm)){
      state.searchExecuted=false;
    }
    if(!search.value){
      state.searchExecuted=false;
      state.lastSearchTerm='';
    }
    renderSearchAction();

    if(state.mode==='sets'){
      renderSets();
      return;
    }

    clearTimeout(state.searchTimer);
    state.searchTimer=setTimeout(()=>suggestCards(search.value),160);
  });

  search.addEventListener('keydown',e=>{
    if(e.key==='Enter'){
      e.preventDefault();
      if(state.mode==='sets'){
        renderSets();
        renderSearchAction();
      }else{
        performSearch(search.value);
      }
    }
  });

  q(root,'[data-btcg-search-submit]').addEventListener('click',()=>{
    if(state.mode==='sets'){
      if(String(search.value||'').trim()){
        search.value='';
        renderSearchAction();
        renderSets();
        search.focus();
      }else{
        renderSets();
      }
      return;
    }

    if(state.searchExecuted){
      resetGlobalSearch();
      search.focus();
      return;
    }

    performSearch(search.value);
  });

  setSearch.addEventListener('input',()=>{
    q(root,'[data-btcg-set-clear]').hidden=!setSearch.value;
    renderCards();
  });

  q(root,'[data-btcg-set-clear]').addEventListener('click',()=>{
    setSearch.value='';q(root,'[data-btcg-set-clear]').hidden=true;renderCards();setSearch.focus();
  });

  q(root,'[data-btcg-clear-filters]').addEventListener('click',()=>{
    state.facets={};state.stockOnly=false;q(root,'[data-btcg-stock-only]').checked=false;
    renderFilters();renderCards();
  });

  q(root,'[data-btcg-stock-only]').addEventListener('change',e=>{
    state.stockOnly=e.target.checked;renderCards();
  });

  q(root,'[data-btcg-sort]').addEventListener('change',e=>{
    state.sort=e.target.value||'collector_asc';
    renderCards();
  });

  q(root,'[data-btcg-search-clear-filters]').addEventListener('click',()=>{
    state.searchFacets={};
    state.searchStockOnly=false;
    q(root,'[data-btcg-search-stock-only]').checked=false;
    renderSearchFilters();
    renderSearchResults();
  });

  q(root,'[data-btcg-search-stock-only]').addEventListener('change',e=>{
    state.searchStockOnly=e.target.checked;
    renderSearchResults();
  });

  qa(root,'[data-set-layout]').forEach(btn=>btn.addEventListener('click',()=>{
    q(root,'[data-btcg-search-clear-filters]').addEventListener('click',()=>{
    state.searchFacets={};
    state.searchStockOnly=false;
    q(root,'[data-btcg-search-stock-only]').checked=false;
    renderSearchFilters();
    renderSearchResults();
  });

  q(root,'[data-btcg-search-stock-only]').addEventListener('change',e=>{
    state.searchStockOnly=e.target.checked;
    renderSearchResults();
  });

  qa(root,'[data-set-layout]').forEach(x=>x.classList.toggle('is-active',x===btn));
    q(root,'[data-btcg-cards]').classList.toggle('is-list',btn.dataset.setLayout==='list');
  }));

  qa(root,'[data-search-layout]').forEach(btn=>btn.addEventListener('click',()=>{
    qa(root,'[data-search-layout]').forEach(x=>x.classList.toggle('is-active',x===btn));
    q(root,'[data-btcg-search-results]').classList.toggle('is-list',btn.dataset.searchLayout==='list');
  }));

  qa(root,'[data-btcg-lightbox-close]').forEach(b=>{
    if(b.classList.contains('btcg-lightbox__close')) b.innerHTML=handXSvg();
    b.addEventListener('click',closeLightbox);
  });
  q(root,'[data-btcg-lightbox-image]')?.addEventListener('click',e=>{e.stopPropagation();closeLightbox();});
  q(root,'[data-btcg-lightbox-flip]').addEventListener('click',flipLightbox);
  document.addEventListener('keydown',e=>{if(e.key==='Escape'&&!q(root,'[data-btcg-lightbox]').hidden)closeLightbox()});
  window.addEventListener('popstate',hydrateFromUrl);

  async function enterGame(btn,replace=false){
    const next=gameKey(btn.dataset.game);
    if(state.game!==next)resetAllTransient();
    state.game=next;state.gameName=btn.dataset.name||btn.dataset.game;
    state.examples=String(btn.dataset.examples||'').split(',').map(x=>x.trim()).filter(Boolean);
    state.collectionManifest=null;
    renderGameHeading();
    await loadCollectionManifest();
    const clean=knownGameCollection();
    if(clean){
      const cleanPath=new URL(clean,location.origin).pathname;
      if(location.pathname!==cleanPath){location.href=clean;return;}
    }
    show('game');setMode('cards',false,true);
    if(!location.pathname.startsWith('/collections/'))setUrl({game:state.game,mode:'cards'},replace);
    rotatePlaceholder();
  }

  function setMode(mode,push,skipReset){
    if(!skipReset)resetAllTransient();
    state.mode=mode==='sets'?'sets':'cards';
    if(browseButton)browseButton.hidden=state.game!=='mtg'||state.mode!=='cards';
    search.value='';suggestions.hidden=true;state.searchExecuted=false;state.lastSearchTerm='';renderSearchAction();

    qa(root,'[data-mode]').forEach(btn=>{
      const on=btn.dataset.mode===state.mode;
      btn.classList.toggle('is-active',on);
      btn.setAttribute('aria-selected',on?'true':'false');
    });

    panels.cards.hidden=state.mode!=='cards';
    panels.sets.hidden=state.mode!=='sets';
    const advanced=q(root,'.btcg-advanced-search');
    if(advanced)advanced.hidden=state.mode!=='cards';
    search.placeholder=state.mode==='sets'?'Encuentra una expansión…':'Busca algo increíble…';

    if(push && !isCurrentGameCollection())setUrl({game:state.game,mode:state.mode});
    if(state.mode==='sets')loadSets();
    rotatePlaceholder();
  }

  // V46D_GAME_STAT_LOOKUP
  function gameStatElement(canonical){
    const exact=q(root,`[data-game-stats="${CSS.escape(canonical)}"]`);
    if(exact)return exact;
    const btn=qa(root,'[data-game]').find(b=>gameKey(b.dataset.game)===canonical);
    if(!btn)return null;
    return q(btn,'[data-game-stats]') || null;
  }

  // V48B_RETRY_EMPTY_SETS
  async function loadSets(){
    const status=q(root,'[data-btcg-status]');
    if(state.setsStockOnly)loadSetStock();
    if(Array.isArray(state.setsByGame[state.game]) && state.setsByGame[state.game].length){
      populateYears();renderModeControls();renderSets();return;
    }

    status.textContent='Cargando expansiones…';

    try{
      const payload=await getJson(`catalog/${state.game}/sets.json`);
      const rows=arr(payload);

      if(payload?.game && gameKey(payload.game)!==state.game)throw new Error('GAME_MISMATCH');
      if(rows.some(s=>s.game && gameKey(s.game)!==state.game))throw new Error('GAME_MISMATCH');

      state.setsByGame[state.game]=rows;
      status.textContent='';
      populateYears();renderModeControls();renderSets();

      const st=gameStatElement(state.game);
      if(st)st.textContent=rows.length+' expansiones';
    }catch(e){
      console.warn('[TCG Singles sets]',state.game,e);
      delete state.setsByGame[state.game];
      status.textContent='Este catálogo todavía no está publicado para este juego.';
      q(root,'[data-btcg-set-groups]').innerHTML='';
    }
  }

  const currentSets=()=>state.setsByGame[state.game]||[];

  // V47B_ADAPTIVE_YEAR_UI
  function availableYears(){
    return [...new Set(currentSets().filter(passesSetStock).map(yearOf).filter(Boolean))].sort().reverse();
  }

  function syncYearCapability(){
    const years=availableYears();
    const hasYears=currentSets().some(s=>Boolean(yearOf(s)));
    const yearBtn=q(root,'[data-group="year"]');
    const azBtn=q(root,'[data-group="az"]');
    const yearWrap=q(root,'[data-btcg-year-wrap]');

    if(yearBtn){
      yearBtn.hidden=!hasYears;
      yearBtn.disabled=!hasYears;
      yearBtn.setAttribute('aria-hidden',hasYears?'false':'true');
    }

    if(!hasYears && state.group==='year'){
      state.group='az';
      state.letter='';
    }

    if(yearBtn)yearBtn.classList.toggle('is-active',hasYears && state.group==='year');
    if(azBtn)azBtn.classList.toggle('is-active',state.group==='az');
    if(yearWrap)yearWrap.hidden=!hasYears || state.group!=='year';

    return {hasYears,years};
  }

  function populateYears(){
    const sel=q(root,'[data-btcg-year]');
    const capability=syncYearCapability();
    if(!sel)return;

    const current=sel.value;
    sel.innerHTML='<option value="">Todos</option>'+
      capability.years.map(y=>`<option value="${esc(y)}">${esc(y)}</option>`).join('');

    sel.value=capability.years.includes(current)?current:'';
    sel.disabled=!capability.hasYears;
    sel.onchange=renderSets;
  }

  function renderModeControls(){
    const alpha=q(root,'[data-btcg-alpha]');
    const yearWrap=q(root,'[data-btcg-year-wrap]');
    const capability=syncYearCapability();

    if(alpha)alpha.hidden=state.group!=='az';
    if(yearWrap)yearWrap.hidden=!capability.hasYears || state.group!=='year';

    if(state.group==='az' && alpha){
      const letters=['#',...'ABCDEFGHIJKLMNOPQRSTUVWXYZ'];
      const available=new Set(currentSets().filter(isPhysicalSet).filter(passesSetType).filter(passesSetStock).map(s=>{
        const c=norm(s.name||'').charAt(0).toUpperCase();
        return /[A-Z]/.test(c)?c:'#';
      }));

      alpha.innerHTML=letters.map(l=>
        `<button class="${state.letter===l?'is-active':''}" data-letter="${l}" ${!available.has(l)?'disabled':''}>${l}</button>`
      ).join('');

      qa(alpha,'[data-letter]').forEach(b=>b.addEventListener('click',()=>{
        if(b.disabled)return;
        state.letter=b.dataset.letter;
        renderModeControls();
        renderSets();
      }));
    }else if(alpha){
      alpha.innerHTML='';
    }

    renderSetTypeControls();
  }

  function isPhysicalSet(s){
    return !(s?.digital===true || s?.is_digital===true || s?.physical===false);
  }

  function setBucket(s){
    const t=norm(s?.set_type||s?.type||'');
    const n=norm(s?.name||'');
    if(t.includes('promo')||n.includes('promo')||n.includes('promotional'))return 'promo';
    if(t.includes('token'))return 'token';
    if(t.includes('commander'))return 'commander';

    if(state.game==='mtg'){
      if(['expansion','core','masters','masterpiece','draft innovation','draft_innovation'].includes(t))return 'main';
      return 'other';
    }
    return 'main';
  }

  function passesSetType(s){
    if(state.setType==='all')return true;
    return setBucket(s)===state.setType;
  }

  function renderSetTypeControls(){
    const host=q(root,'[data-btcg-set-types]');
    if(!host)return;

    const physical=currentSets().filter(isPhysicalSet);
    const defs=[
      ['all','Todos'],
      ['main','Principales'],
      ['commander','Commander'],
      ['promo','Promos'],
      ['token','Tokens']
    ];

    const available=defs.map(([key,label])=>{
      const count=key==='all'?physical.length:physical.filter(s=>setBucket(s)===key).length;
      return {key,label,count};
    }).filter(x=>x.key==='all'||x.count);

    host.innerHTML=`
      <div class="btcg-set-type-buttons">
        ${available.map(x=>`<button type="button" class="${state.setType===x.key?'is-active':''}" data-set-type="${x.key}">
          ${x.label}<span>${x.count}</span>
        </button>`).join('')}
      </div>
      <label class="btcg-set-type-select">
        <span>Tipo de expansión</span>
        <select data-set-type-select>
          ${available.map(x=>`<option value="${x.key}" ${state.setType===x.key?'selected':''}>${x.label} (${x.count})</option>`).join('')}
        </select>
      </label>`;

    qa(host,'[data-set-type]').forEach(btn=>btn.addEventListener('click',()=>{
      state.setType=btn.dataset.setType;
      state.letter='';
      renderModeControls();
      renderSets();
    }));

    q(host,'[data-set-type-select]')?.addEventListener('change',e=>{
      state.setType=e.target.value||'all';
      state.letter='';
      renderModeControls();
      renderSets();
    });
  }

  function compareDateDesc(a,b){
    return String(b.released_at||b.release_date||'').localeCompare(String(a.released_at||a.release_date||''));
  }

  // V47_DISPLAY_SET_CODE
  function displaySetCode(s){
    const raw=String(s?.display_code||s?.code||'').trim().toUpperCase();
    if(!raw)return'';
    if(/^\d{4,}$/.test(raw))return'';
    if(/^(?:GUND|GUNDAM|SWU|DBFW|DBM|DBSM|DBSFW|DIGIMON|ONEPIECE|LORCANA)[-_]?\d+$/i.test(raw))return'';
    if(raw.length>12)return'';
    return raw;
  }

  function setRow(s){
    const code=String(s.code||'').toUpperCase(); // technical routing code
    const showCode=displaySetCode(s);
    const symbol=actualSetIcon(s);
    const year=yearOf(s);
    const sub=[showCode,year].filter(Boolean).join(' · ');

    return `<button type="button" class="btcg-set-row" data-open-set="${esc(code)}">
      <span class="btcg-set-row__symbol">${symbol?`<img src="${esc(symbol)}" width="38" height="38" loading="lazy" alt="">`:`<b>${esc((showCode||gameAcronym()).slice(0,6))}</b>`}</span>
      <span class="btcg-set-row__main">
        <strong>${esc(s.name||showCode||'Expansión')}</strong>
        ${sub?`<small>${esc(sub)}</small>`:''}
      </span>
      <span class="btcg-set-row__count">${countOf(s)?countOf(s)+' cartas':''}</span>
    </button>`;
  }

  // V48B_SAFE_SET_ICONS
  function actualSetIcon(s){
    const vals=[s?.symbol_uri,s?.icon_uri,s?.icon_svg,s?.icon_svg_uri,s?.logo_uri,s?.set_logo,s?.assets?.symbol,s?.assets?.icon,s?.assets?.logo];
    const urls=vals.filter(u=>/^https?:\/\//i.test(String(u||'')));
    if(state.game==='lorcana')return urls.find(u=>/(symbol|icon|logo|set-mark|set_mark)/i.test(String(u)))||'';
    return urls[0]||'';
  }

  async function resolveSetIcon(s){
    const direct=actualSetIcon(s);
    if(direct)return direct;
    if(s?.__resolvedSetIcon!==undefined)return s.__resolvedSetIcon;
    const candidates=[s?.icon_svg_uri,s?.assets?.symbol,s?.assets?.logo].filter(Boolean);
    const api=candidates.find(u=>/^https:\/\/api\.scryfall\.com\/sets\//i.test(String(u)));
    if(!api){s.__resolvedSetIcon='';return '';}
    try{
      const r=await fetch(api,{headers:{Accept:'application/json'},cache:'force-cache'});
      if(!r.ok)throw new Error('HTTP '+r.status);
      const data=await r.json();
      const icon=String(data?.icon_svg_uri||'');
      s.__resolvedSetIcon=icon;
      return icon;
    }catch(_e){
      s.__resolvedSetIcon='';
      return '';
    }
  }

  function groupHtml(title,items,subtitle=''){
    if(!items.length)return'';
    return `<section class="btcg-set-group">
      <header class="btcg-set-group__head">
        <div><h3>${esc(title)}</h3>${subtitle?`<p>${esc(subtitle)}</p>`:''}</div>
        <span>${items.length}</span>
      </header>
      <div class="btcg-set-group__rows">${items.map(setRow).join('')}</div>
    </section>`;
  }

  function renderSets(){
    const term=norm(search.value);
    const yearFilter=q(root,'[data-btcg-year]').value;

    let list=currentSets()
      .filter(isPhysicalSet)
      .filter(passesSetType)
      .filter(passesSetStock)
      .filter(s=>!term||norm(`${s.name||''} ${s.display_code||''} ${s.code||''}`).includes(term));

    const host=q(root,'[data-btcg-set-groups]');
    const stockStatus=q(root,'[data-btcg-sets-stock-status]');
    const pending=state.setsStockOnly&&state.setStockPending[state.game];
    const error=state.setsStockOnly&&state.setStockErrors[state.game];
    if(stockStatus){
      stockStatus.textContent=pending?'Consultando stock…':(error||'');
      if(error){
        const retry=document.createElement('button');retry.type='button';retry.textContent='Reintentar';
        retry.addEventListener('click',()=>{loadSetStock();renderSets();});stockStatus.append(' ',retry);
      }
    }
    host.setAttribute('aria-busy',pending?'true':'false');
    if(pending||error){host.innerHTML='';return;}

    if(state.group==='year'){
      list.sort(compareDateDesc);

      if(yearFilter){
        const only=list.filter(s=>yearOf(s)===yearFilter);
        host.innerHTML=groupHtml(yearFilter,only);
      }else{
        const years=[...new Set(list.map(yearOf).filter(Boolean))].sort().reverse();
        host.innerHTML=years.map(y=>groupHtml(y,list.filter(s=>yearOf(s)===y))).join('');
      }
    }

    if(state.group==='az'){
      const letterOf=s=>{
        const c=norm(s.name||'').charAt(0).toUpperCase();
        return /[A-Z]/.test(c)?c:'#';
      };

      list.sort((a,b)=>String(a.name||'').localeCompare(String(b.name||''),'es',{sensitivity:'base'}));

      if(state.letter){
        const only=list.filter(s=>letterOf(s)===state.letter);
        host.innerHTML=groupHtml(state.letter,only);
      }else{
        const letters=['#',...'ABCDEFGHIJKLMNOPQRSTUVWXYZ'].filter(l=>list.some(s=>letterOf(s)===l));
        host.innerHTML=letters.map(l=>groupHtml(l,list.filter(s=>letterOf(s)===l))).join('');
      }
    }

    if(!host.innerHTML.trim()){
      host.innerHTML='<div class="btcg__empty-state"><strong>No encontré expansiones.</strong><span>Prueba otro filtro.</span></div>';
    }

    qa(host,'[data-open-set]').forEach(btn=>btn.addEventListener('click',()=>{
      const code=String(btn.dataset.openSet||'').toUpperCase();
      const clean=knownSetCollection(code);
      if(clean){location.href=clean;return;}
      // Si todavía no existe una landing SEO limpia para esta expansión,
      // usamos la URL dinámica única. Nunca mostramos otra expansión bajo
      // /collections/<juego>-singles porque URL y contenido quedarían desalineados.
      location.href=dynamicSetUrl(code);
    }));
  }

  function shardFor(term){
    const c=norm(term).charAt(0);
    if(/[a-z]/.test(c))return c;
    if(/[0-9]/.test(c))return '0-9';
    return '_';
  }

  async function searchIndexMatches(term,limit=20){
    term=norm(term);
    if(term.length<2)return[];
    const payload=await getJson(`catalog/${state.game}/search/shards/${encodeURIComponent(shardFor(term))}.json`);
    if(payload?.game && gameKey(payload.game)!==state.game)throw new Error('GAME_MISMATCH');
    return arr(payload).filter(r=>norm(r.name||'').includes(term)).slice(0,limit);
  }

  async function expandPrintings(matches,term,maxSets=36){
    const wanted=norm(term);
    const codes=[...new Set(matches.flatMap(r=>Array.isArray(r.sets)?r.sets:[]).map(x=>String(x).toUpperCase()))].slice(0,maxSets);
    if(!codes.length)return matches;

    const settled=await Promise.allSettled(codes.map(async code=>{
      const payload=await getJson(`catalog/${state.game}/sets/set-${code.toLowerCase()}.json`);
      return arr(payload).filter(c=>norm(c.name||'').includes(wanted));
    }));

    const printings=settled.flatMap(x=>x.status==='fulfilled'?x.value:[]);
    const seen=new Set();

    return printings.filter(c=>{
      const k=`${setCode(c)}|${collector(c)}|${String(c.language||'')}|${String(c.finish||c.finishes||'')}`;
      if(seen.has(k))return false;
      seen.add(k);return true;
    });
  }

  function metaValues(c,key){
    if(key==='subtype')return cardSubtypesOnly(c);
    if(key==='type')return cardTypesOnly(c);
    if(key==='artist')return cardArtists(c);
    return [];
  }

  function matchesMeta(c,key,value){
    const wanted=norm(value);
    return metaValues(c,key).some(v=>norm(v)===wanted);
  }

  async function metadataIndexMatches(key,value){
    const idx=await getJson(`catalog/${state.game}/search/index.json`);
    const files=Object.values(idx?.shards||{}).map(x=>x?.file).filter(Boolean);
    const settled=await Promise.allSettled(files.map(file=>getJson(`catalog/${state.game}/search/${String(file).replace(/^search\//,'')}`)));
    const rows=settled.flatMap(x=>x.status==='fulfilled'?arr(x.value):[]);
    const direct=rows.filter(r=>matchesMeta(r,key,value));
    if(direct.length)return direct;

    const setsPayload=await getJson(`catalog/${state.game}/sets.json`);
    const scanLimit=state.game==='pokemon'?240:(state.game==='fab'?500:180);
    const sets=arr(setsPayload).filter(isPhysicalSet).slice(0,scanLimit);
    const hits=[];
    const scanned=await Promise.allSettled(sets.map(async s=>{
      const code=String(s?.code||s?.set_code||s?.id||'').toUpperCase();
      if(!code)return null;
      const payload=await getJson(`catalog/${state.game}/sets/set-${code.toLowerCase()}.json`);
      return arr(payload).some(c=>matchesMeta(c,key,value))?code:null;
    }));
    scanned.forEach(x=>{if(x.status==='fulfilled'&&x.value)hits.push(x.value)});
    return hits.length?[{name:String(value),sets:[...new Set(hits)]}]:[];
  }

  async function expandMetadataPrintings(matches,key,value,maxSets=160){
    const codes=[...new Set(matches.flatMap(r=>Array.isArray(r.sets)?r.sets:[]).map(x=>String(x).toUpperCase()))].slice(0,maxSets);
    const settled=await Promise.allSettled(codes.map(async code=>{
      const payload=await getJson(`catalog/${state.game}/sets/set-${code.toLowerCase()}.json`);
      return arr(payload).filter(c=>matchesMeta(c,key,value));
    }));
    const rows=settled.flatMap(x=>x.status==='fulfilled'?x.value:[]), seen=new Set();
    return rows.filter(c=>{
      const k=`${setCode(c)}|${collector(c)}|${String(c.language||'')}|${String(c.finish||c.finishes||'')}`;
      if(seen.has(k))return false; seen.add(k); return true;
    });
  }

  async function exactCardVersionMatches(value){
    const wanted=norm(value);
    if(!wanted)return [];
    const idxRows=await searchIndexMatches(value,40);
    const exact=idxRows.filter(r=>norm(r?.name)===wanted);
    const codes=[...new Set(exact.flatMap(r=>Array.isArray(r.sets)?r.sets:[]).map(x=>String(x).toUpperCase()))];
    const settled=await Promise.allSettled(codes.map(async code=>{
      const payload=await getJson(`catalog/${state.game}/sets/set-${code.toLowerCase()}.json`);
      return arr(payload).filter(c=>norm(c?.name)===wanted);
    }));
    const rows=settled.flatMap(x=>x.status==='fulfilled'?x.value:[]), seen=new Set();
    return rows.filter(c=>{
      const k=`${setCode(c)}|${collector(c)}|${String(c.language||c.lang||'')}|${String(c.finish||c.finishes||'')}`;
      if(seen.has(k))return false; seen.add(k); return true;
    });
  }

  async function performCardVersionsSearch(value){
    if(browse.active)stopBrowse();
    q(root,'[data-btcg-sort-wrap]')?.removeAttribute('hidden');
    value=String(value||'').trim(); if(!value)return;
    setMode('cards',false,true);
    const status=q(root,'[data-btcg-search-status]');
    if(status)status.textContent='Buscando versiones…';
    try{
      const rows=await exactCardVersionMatches(value);
      await enrichWithCommerce(rows);
      state.searchResults=groupYgoRows(rows,state.game); state.searchFacets={}; state.searchStockOnly=false; state.searchExecuted=true; state.lastSearchTerm='';
      const stockOnly=q(root,'[data-btcg-search-stock-only]'); if(stockOnly)stockOnly.checked=false;
      const catalog=q(root,'[data-btcg-search-catalog]'); if(catalog)catalog.hidden=false;
      const title=q(root,'[data-btcg-result-title]'); if(title)title.textContent=`Todas las versiones de “${value}”`;
      setMode('cards',false,true); renderSearchAction(); renderSearchFilters(); renderSearchResults();
      if(status)status.textContent=rows.length?`${rows.length} ${rows.length===1?'impresión':'impresiones'}`:'No se encontraron otras impresiones de esta carta.';
    }catch(e){console.warn('[TCG Singles card versions]',value,e);setMode('cards',false,true);if(status)status.textContent='No se pudieron cargar las versiones.'}
  }

  async function performMetadataSearch(key,value){
    if(browse.active)stopBrowse();
    q(root,'[data-btcg-sort-wrap]')?.removeAttribute('hidden');
    value=String(value||'').trim(); if(!value)return;

    // 066H: un filtro de metadatos SIEMPRE representa una vista de cartas.
    // Las colecciones de juego abren por defecto en expansiones, así que forzamos
    // explícitamente el panel de cartas antes y después de resolver el índice.
    setMode('cards',false,true);
    const status=q(root,'[data-btcg-search-status]');
    if(status)status.textContent='Buscando impresiones…';

    try{
      const matches=await metadataIndexMatches(key,value);
      const rows=await expandMetadataPrintings(matches,key,value);
      await enrichWithCommerce(rows);

      state.searchResults=groupYgoRows(rows,state.game);
      state.searchFacets={};
      state.searchStockOnly=false;
      state.searchExecuted=true;
      state.lastSearchTerm='';

      const stockOnly=q(root,'[data-btcg-search-stock-only]');
      if(stockOnly)stockOnly.checked=false;
      const catalog=q(root,'[data-btcg-search-catalog]');
      if(catalog)catalog.hidden=false;
      const title=q(root,'[data-btcg-result-title]');
      if(title){
        title.textContent=key==='artist'
          ?`Cartas ilustradas por “${value}”`
          :key==='type'
            ?`Cartas de tipo “${value}”`
            :`Cartas con subtipo “${value}”`;
      }

      // Reafirma el modo por si una carga asíncrona del contexto de colección
      // intentó restaurar "expansiones" mientras se resolvían los shards.
      setMode('cards',false,true);
      renderSearchAction();
      renderSearchFilters();
      renderSearchResults();

      if(status){
        status.textContent=rows.length?'':
          'No hay coincidencias publicadas para este filtro.';
      }
    }catch(e){
      console.warn('[TCG Singles metadata search]',key,value,e);
      setMode('cards',false,true);
      if(status)status.textContent='No se pudo completar el filtro.';
    }
  }

  async function suggestCards(term){
    if(browse.active)return;
    term=String(term||'').trim();
    if(term.length<2){suggestions.hidden=true;return;}

    try{
      if(collectorQuery(term)){suggestions.hidden=true;return;}
      const rows=await searchIndexMatches(term,8);
      if(!rows.length){suggestions.hidden=true;return;}

      suggestions.innerHTML=rows.map((r,i)=>`<button type="button" data-suggest="${i}">
        ${r.image?`<img src="${esc(r.image)}" width="42" height="58" loading="lazy" alt="">`:''}
        <span><strong>${esc(r.name)}</strong><small>${r.printings?esc(r.printings)+' impresiones':''}</small></span>
      </button>`).join('');

      suggestions.hidden=false;

      qa(suggestions,'[data-suggest]').forEach((b,i)=>b.addEventListener('click',()=>{
        search.value=rows[i].name;suggestions.hidden=true;performSearch(rows[i].name);
      }));
    }catch(e){
      suggestions.hidden=true;
    }
  }

  async function collectorNumberSearch(query){
    const setsPayload=await getJson(`catalog/${state.game}/sets.json`);
    let sets=arr(setsPayload).filter(isPhysicalSet);

    // 125/226: denominator is a strong hint. Prefer sets whose published count is 226.
    if(query.total){
      const narrowed=sets.filter(s=>countOf(s)===query.total);
      if(narrowed.length)sets=narrowed;
    }

    // Safety: current catalogs are small enough to scan. Load in chunks to avoid browser bursts.
    const out=[];
    const chunk=16;
    for(let i=0;i<sets.length;i+=chunk){
      const batch=sets.slice(i,i+chunk);
      const settled=await Promise.allSettled(batch.map(async s=>{
        const code=String(s.code||s.set_code||'').toUpperCase();
        if(!code)return[];
        const payload=await getJson(`catalog/${state.game}/sets/set-${code.toLowerCase()}.json`);
        return arr(payload).filter(c=>collectorMatches(c,query));
      }));
      out.push(...settled.flatMap(x=>x.status==='fulfilled'?x.value:[]));
    }

    const seen=new Set();
    return out.filter(c=>{
      const k=`${setCode(c)}|${collector(c)}|${String(c.language||c.lang||'')}|${String(c.finish||c.finishes||'')}`;
      if(seen.has(k))return false;
      seen.add(k);return true;
    });
  }

  async function performCollectorNumberSearch(term){
    if(browse.active)stopBrowse();
    const query=collectorQuery(term);
    if(!query)return false;

    q(root,'[data-btcg-sort-wrap]')?.removeAttribute('hidden');
    suggestions.hidden=true;
    const status=q(root,'[data-btcg-search-status]');
    status.textContent=`Buscando #${query.number}${query.total?'/'+query.total:''}…`;

    const rows=await collectorNumberSearch(query);
    await enrichWithCommerce(rows);

    state.searchResults=groupYgoRows(rows,state.game);
    state.searchFacets={};
    state.searchStockOnly=false;
    state.searchExecuted=true;
    state.lastSearchTerm=term;
    q(root,'[data-btcg-search-stock-only]').checked=false;
    q(root,'[data-btcg-search-catalog]').hidden=false;

    q(root,'[data-btcg-result-title]').textContent=
      `Resultados para #${query.number}${query.total?'/'+query.total:''}`;

    renderSearchAction();
    renderSearchFilters();
    renderSearchResults();
    status.textContent='';
    return true;
  }

  async function performSearch(term){
    if(browse.active){browse.page=1;renderBrowseResults();return;}
    q(root,'[data-btcg-sort-wrap]')?.removeAttribute('hidden');
    term=String(term||'').trim();
    suggestions.hidden=true;
    if(term.length<2)return;

    const status=q(root,'[data-btcg-search-status]');
    status.textContent='Buscando impresiones…';

    try{
      if(collectorQuery(term)){
        await performCollectorNumberSearch(term);
        return;
      }
      const matches=await searchIndexMatches(term,20);
      const rows=await expandPrintings(matches,term);
      await enrichWithCommerce(rows);

      state.searchResults=groupYgoRows(rows,state.game);
      state.searchFacets={};
      state.searchStockOnly=false;
      state.searchExecuted=true;
      state.lastSearchTerm=term;
      q(root,'[data-btcg-search-stock-only]').checked=false;
      q(root,'[data-btcg-search-catalog]').hidden=false;

      q(root,'[data-btcg-result-title]').textContent=`Resultados para “${term}”`;

      renderSearchAction();
      renderSearchFilters();
      renderSearchResults();
      status.textContent='';
    }catch(e){
      console.warn('[TCG Singles search]',state.game,e);
      q(root,'[data-btcg-search-catalog]').hidden=false;
      q(root,'[data-btcg-result-title]').textContent=`Resultados para “${term}”`;
      q(root,'[data-btcg-result-count]').textContent='';
      q(root,'[data-btcg-search-results]').innerHTML='<div class="btcg__empty-state"><strong>Este buscador todavía no está publicado para este juego.</strong></div>';
      status.textContent='';
    }
  }

  function searchPrintingHtml(c){
    const img=displayImageForCard(c,state);
    return `<article class="btcg-card btcg-card--search" data-can-flip="${canFlipCard(c)?'1':'0'}" data-has-back="${backImage(c)?'1':'0'}">
      <div class="btcg-card__media">
        <button class="btcg-card__image-button" type="button" data-zoom-card>
          <span class="btcg-card__image-wrap">
            ${img?`<img class="btcg-card__image" src="${esc(img)}" width="488" height="680" loading="lazy" alt="${esc(faceName(c,0)||c.name||'Carta')}">`:''}
          </span>
        </button>
        ${canFlipCard(c)&&backImage(c)?`<button class="btcg-card__flip-inline" type="button" data-flip-inline aria-label="Ver reverso" title="Ver reverso">${handRotateSvg()}</button>`:''}
      </div>

      <div class="btcg-card__body">
        <div class="btcg-card__info">
          <strong>${productNameHtml(c)}</strong>
          <small>${cardReferenceHtml(c,setCode(c),{search:true})}</small>

          <div class="btcg-card__list-extra">
            <small><b>Rareza:</b> ${esc(displayRarities(c))}</small>
            <small><b>Tipo:</b> <span data-card-face-type>${esc(faceType(c,0)||c.type_line||c.card_type||displayCardTypes(c))}</span></small>
            <small><b>Artista:</b> ${esc(c.artist||c.illustrator||'—')}</small>
          </div>
          ${commerceSummaryHtml(c)}
        </div>

        <div class="btcg-card__commerce">
          ${commerceHtml(c)}
        </div>
      </div>
    </article>`;
  }

  /* BURRO_V50H2_BROWSER_METADATA_MERGE_20260827 */
  function v50h2Norm(v){
    return String(v??'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().trim();
  }
  function v50h2Collector(v){
    const s=String(v??'').trim().toUpperCase().replace(/\s+/g,'');
    const p=s.split('/');
    if(p.length===2&&/^\d+$/.test(p[0])&&/^\d+$/.test(p[1]))return `${Number(p[0])}/${Number(p[1])}`;
    return s;
  }
  function v50h2Rows(p){
    if(Array.isArray(p))return p;
    if(Array.isArray(p?.records))return p.records;
    return [];
  }
  function v50h2Empty(v){
    return v==null||v===''||(Array.isArray(v)&&!v.length)||(typeof v==='object'&&!Array.isArray(v)&&!Object.keys(v).length);
  }
  function v50h2MergeCard(card,row){
    if(!card||!row)return card;
    const meta=row.metadata||{};
    card.metadata_v50=meta;

    Object.entries(meta).forEach(([k,v])=>{
      if(!v50h2Empty(v)&&v50h2Empty(card[k]))card[k]=v;
    });

    if(meta.artist&&v50h2Empty(card.artist))card.artist=meta.artist;
    if(Array.isArray(meta.artists)&&meta.artists.length&&v50h2Empty(card.artists))card.artists=meta.artists;

    if(meta.type){
      if(v50h2Empty(card.card_type))card.card_type=meta.type;
      if(v50h2Empty(card.types))card.types=[meta.type];
    }

    const subs=meta.subtypes||meta.classifications;
    if(Array.isArray(subs)&&subs.length&&v50h2Empty(card.subtypes))card.subtypes=subs;

    const colors=(Array.isArray(meta.colors)&&meta.colors.length)
      ? meta.colors
      : (meta.ink?[meta.ink]:(Array.isArray(meta.aspect)?meta.aspect:[]));
    if(colors.length&&v50h2Empty(card.colors))card.colors=colors;

    if(Array.isArray(meta.traits)&&meta.traits.length&&v50h2Empty(card.traits))card.traits=meta.traits;

    const attr=meta.attribute||(Array.isArray(meta.attributes)&&meta.attributes.length?meta.attributes[0]:'');
    if(attr&&v50h2Empty(card.attribute))card.attribute=attr;

    if(meta.legalities&&!v50h2Empty(meta.legalities)&&v50h2Empty(card.legalities))card.legalities=meta.legalities;
    return card;
  }
  async function v50h2MergeSetMetadata(cards,game,code){
    if(!Array.isArray(cards)||!cards.length||!game||!code)return cards;
    try{
      const overlay=await getJson(`catalog-meta/v50/${game}/sets/set-${String(code).toLowerCase()}.json`);
      const rows=v50h2Rows(overlay);
      if(!rows.length)return cards;

      const byProduct=new Map();
      const byPhysical=new Map();
      rows.forEach(r=>{
        if(r?.product_key)byProduct.set(String(r.product_key),r);
        const key=`${v50h2Collector(r?.collector_number)}|${v50h2Norm(r?.name)}`;
        if(!byPhysical.has(key))byPhysical.set(key,[]);
        byPhysical.get(key).push(r);
      });

      let merged=0;
      cards.forEach(c=>{
        let row=null;
        if(c?.product_key&&byProduct.has(String(c.product_key))){
          row=byProduct.get(String(c.product_key));
        }else{
          const key=`${v50h2Collector(c?.collector_number||c?.card_number||c?.number)}|${v50h2Norm(c?.name)}`;
          const hits=byPhysical.get(key)||[];
          if(hits.length===1)row=hits[0];
        }
        if(row){v50h2MergeCard(c,row);merged++}
      });
      console.info(`[Burro V50 metadata] ${game} ${code}: ${merged}/${cards.length} merged`);
      return cards;
    }catch(e){
      console.warn('[Burro V50 metadata set]',game,code,e);
      return cards;
    }
  }

  async function openSet(code){
    if(browse.active)stopBrowse();
    const requested=String(code||'').toUpperCase(),meta=setMetaByTechnicalCode(requested);
    state.setCode=String(meta?.code||requested).toUpperCase();
    const showCode=displaySetCode(meta);
    q(root,'[data-btcg-set-code]').textContent=[state.gameName,showCode].filter(Boolean).join(' · ');
    q(root,'[data-btcg-set-title]').textContent=meta?.name||showCode||'Expansión';
    q(root,'[data-btcg-set-summary]').textContent=[yearOf(meta),countOf(meta)?countOf(meta)+' cartas':''].filter(Boolean).join(' · ');
    const icon=await resolveSetIcon(meta);
    q(root,'[data-btcg-set-symbol]').innerHTML=icon?`<img src="${esc(icon)}" width="42" height="42" alt="">`:`<span>${esc(showCode||gameAcronym())}</span>`;
    show('set'); if(!location.pathname.startsWith('/collections/'))setUrl({game:state.game,mode:'sets',set:state.setCode});
    q(root,'[data-btcg-set-status]').textContent='Cargando cartas…';
    try{
      const files=Array.isArray(meta?.member_files)&&meta.member_files.length?meta.member_files:[String(meta?.file||`sets/set-${state.setCode.toLowerCase()}.json`)];
      const payloads=await Promise.all(files.map(f=>getJson(`catalog/${state.game}/${String(f).replace(/^\/+/, '')}`)));
      state.cards=payloads.flatMap(p=>arr(p)); state.facets={}; state.stockOnly=false; await enrichWithCommerce(state.cards); await v50h2MergeSetMetadata(state.cards,state.game,state.setCode);
      buildFilters(); renderCards(); q(root,'[data-btcg-set-status]').textContent='';
    }catch(e){console.warn('[TCG Singles set]',state.game,state.setCode,e);state.cards=[];buildFilters();renderCards();q(root,'[data-btcg-set-status]').textContent='No pude cargar las cartas de esta expansión.';}
  }

  function actualSetIcon(s){
    const vals=[
      s?.symbol_uri,s?.icon_uri,s?.icon_svg,s?.icon_svg_uri,
      s?.assets?.symbol,s?.assets?.icon
    ];
    return vals.find(u=>/\.svg(\?|$)|\.png(\?|$)|svgs\.scryfall\.io/i.test(String(u||'')))||'';
  }

  async function resolveSetIcon(s){
    const direct=actualSetIcon(s);
    if(direct)return direct;
    if(s?.__resolvedSetIcon!==undefined)return s.__resolvedSetIcon;
    const candidates=[s?.icon_svg_uri,s?.assets?.symbol,s?.assets?.logo].filter(Boolean);
    const api=candidates.find(u=>/^https:\/\/api\.scryfall\.com\/sets\//i.test(String(u)));
    if(!api){s.__resolvedSetIcon='';return '';}
    try{
      const r=await fetch(api,{headers:{Accept:'application/json'},cache:'force-cache'});
      if(!r.ok)throw new Error('HTTP '+r.status);
      const data=await r.json();
      const icon=String(data?.icon_svg_uri||'');
      s.__resolvedSetIcon=icon;
      return icon;
    }catch(_e){
      s.__resolvedSetIcon='';
      return '';
    }
  }

  function legalFormats(c){
    const legal=c?.legalities;
    if(!legal || typeof legal!=='object' || Array.isArray(legal))return [];

    const curated={
      mtg:['standard','pioneer','modern','legacy','vintage','pauper','commander'],
      pokemon:['standard','expanded','unlimited']
    };

    const allowed=curated[state.game]||Object.keys(legal);
    return allowed.filter(k=>{
      const v=legal[k];
      return v===true || String(v).toLowerCase()==='legal';
    }).map(titleCase);
  }

  function cardColors(c){
    let vals=[];
    const raw=c?.colors??c?.color_identity??c?.color??[];
    if(Array.isArray(raw)) vals=raw.slice();
    else if(typeof raw==='string') vals=raw.split(/[\s,|/]+/).filter(Boolean);

    if(c?.is_colorless===true || c?.colorless===true) vals.push('C');

    // MTG cards with no colors are colorless.
    if(state.game==='mtg' && !vals.length) vals.push('C');

    return [...new Set(vals.map(String))];
  }

  function pokemonElementTypes(c){
    if(state.game!=='pokemon')return [];

    const vals=[];
    const raw=c?.types;
    if(Array.isArray(raw))vals.push(...raw.map(String));

    faceArray(c).forEach(face=>{
      if(Array.isArray(face?.types))vals.push(...face.types.map(String));
    });

    const labels={
      grass:'Grass',
      fire:'Fire',
      water:'Water',
      lightning:'Lightning',
      electric:'Lightning',
      psychic:'Psychic',
      fighting:'Fighting',
      darkness:'Darkness',
      dark:'Darkness',
      metal:'Metal',
      dragon:'Dragon',
      colorless:'Colorless',
      fairy:'Fairy'
    };

    return [...new Set(
      vals.filter(Boolean).map(v=>{
        const key=norm(v).replace(/[\s_-]+/g,'');
        return labels[key]||titleCase(v);
      })
    )];
  }

  function cardTypesOnly(c){
    // Pokémon: "Tipo" = tipo elemental real (Grass, Fire, Water, etc.).
    // Pokémon / Trainer / Energy son supertype y NO deben contaminar este facet.
    if(state.game==='pokemon'){
      return pokemonElementTypes(c);
    }

    const vals=[];
    const rawTypes=c?.types;
    if(Array.isArray(rawTypes)) vals.push(...rawTypes.map(String));

    const addFromLine=line=>{
      if(!line)return;
      String(line).split(/\s*\/\/\s*/).forEach(part=>{
        const left=part.split('—')[0].trim();
        left.split(/\s+/).forEach(tok=>{
          const t=tok.trim();
          if(t && !['Legendary','Basic','Snow','World','Ongoing'].includes(t)) vals.push(t);
        });
      });
    };

    faceArray(c).forEach(f=>addFromLine(f?.type_line||f?.card_type||f?.type));
    addFromLine(c?.type_line||c?.card_type);

    return [...new Set(vals.filter(Boolean))];
  }

  function cardSubtypesOnly(c){
    const vals=[];
    const raw=c?.subtypes;
    if(Array.isArray(raw)) vals.push(...raw.map(String));
    const addFromLine=line=>{
      if(!line)return;
      String(line).split(/\s*\/\/\s*/).forEach(part=>{
        const bits=part.split('—');
        if(bits.length<2)return;
        bits.slice(1).join('—').trim().split(/\s+/).forEach(tok=>{if(tok)vals.push(tok.trim())});
      });
    };
    faceArray(c).forEach(f=>addFromLine(f?.type_line||f?.card_type||f?.type));
    addFromLine(c?.type_line||c?.card_type);

    let cleaned=vals.filter(Boolean).map(String);
    if(state.game==='pokemon'){
      const merged=[];
      for(let i=0;i<cleaned.length;i++){
        const current=cleaned[i].trim();
        const key=norm(current).replace(/\s+/g,'');
        const next=String(cleaned[i+1]||'').trim();

        if(key==='stage' && /^[12]$/.test(next)){
          merged.push(`Stage ${next}`);
          i++;
          continue;
        }
        if(key==='stage1'){merged.push('Stage 1');continue;}
        if(key==='stage2'){merged.push('Stage 2');continue;}

        merged.push(current);
      }
      cleaned=merged;
    }

    return [...new Set(cleaned)];
  }

  function cardArtists(c){
    const vals=[];
    if(Array.isArray(c?.artists)) vals.push(...c.artists);
    if(c?.artist) vals.push(c.artist);
    if(c?.illustrator) vals.push(c.illustrator);
    return [...new Set(vals.map(String).filter(Boolean))];
  }

  function expansionFacetValue(c){
    const code=setCode(c);
    const name=String(
      c?.set_name||
      c?.setName||
      c?.expansion_name||
      c?.expansionName||
      (c?.set&&typeof c.set==='object'?(c.set.name||c.set.display_name||''):'')||
      (c?.expansion&&typeof c.expansion==='object'?(c.expansion.name||c.expansion.display_name||''):'')
    ).trim();
    if(name && code && norm(name)!==norm(code)) return `${name} (${code})`;
    return name||code||'';
  }

  // V43_YGO_COHERENT_FACETS
  // YGO uses semantic facets instead of inheriting generic TCG fields.
  function ygoCardCategory(c){
    const raw=[c?.type,c?.card_type,c?.type_line,c?.front_type_line,c?.frame_type]
      .filter(Boolean).join(' ').toLowerCase();
    if(raw.includes('monster'))return 'Monstruo';
    if(raw.includes('spell'))return 'Mágica';
    if(raw.includes('trap'))return 'Trampa';
    if(raw.includes('skill'))return 'Habilidad';
    const direct=String(c?.type||c?.card_type||'').trim();
    return direct && !/^[.\-–—·•]+$/.test(direct) ? titleCase(direct) : '';
  }

  function ygoMonsterType(c){
    if(ygoCardCategory(c)!=='Monstruo')return [];
    const raw=c?.race??c?.monster_type??c?.monsterType??[];
    return values(raw).map(String).map(v=>v.trim())
      .filter(v=>v && !/^[.\-–—·•]+$/.test(v));
  }

  function ygoAttribute(c){
    if(ygoCardCategory(c)!=='Monstruo')return [];
    const raw=String(c?.attribute||'').trim().toUpperCase();
    return raw && !/^[.\-–—·•]+$/.test(raw) ? [raw] : [];
  }

  function ygoArchetypes(c){
    const raw=c?.archetype??c?.archetypes??[];
    return values(raw).flatMap(v=>String(v).split(/\s*[|;]\s*/))
      .map(v=>v.trim()).filter(Boolean);
  }

  function ygoEditionValues(c){
    const raw=[];
    [c?.edition,c?.printing,c?.print,c?.finish,c?.finishes,c?.editions,
     c?.metadata?.edition,c?.metadata?.printing]
      .forEach(v=>raw.push(...values(v)));
    const out=[];
    raw.forEach(v=>{
      const k=norm(v).replace(/[_-]+/g,' ').trim();
      if(/\b1st\b|\bfirst\b/.test(k))out.push('1st');
      else if(k.includes('unlimited'))out.push('Unlimited');
      else if(k.includes('limited'))out.push('Limited');
    });
    return [...new Set(out)];
  }

  const ygoRarityLabels={
    dtpc:'Duel Terminal Normal Parallel Rare',
    dtnpr:'Duel Terminal Normal Parallel Rare',
    dtpsp:'Duel Terminal Rare Parallel Rare',
    dtrpr:'Duel Terminal Rare Parallel Rare',
    dtspr:'Duel Terminal Super Parallel Rare',
    dtupr:'Duel Terminal Ultra Parallel Rare',
    c:'Common',r:'Rare',sr:'Super Rare',ur:'Ultra Rare',
    scr:'Secret Rare',utr:'Ultimate Rare',gr:'Ghost Rare',
    slr:'Starlight Rare',cr:"Collector's Rare",
    qcsr:'Quarter Century Secret Rare',psr:'Prismatic Secret Rare'
  };

  const ygoFacetDefs=[
    ['set','Expansión',c=>expansionFacetValue(c)],
    ['rarity','Rareza',c=>c.rarity],
    ['ygo_card_type','Tipo de carta',c=>ygoCardCategory(c)],
    ['race','Tipo de monstruo',c=>ygoMonsterType(c)],
    ['attribute','Atributo',c=>ygoAttribute(c)],
    ['ygo_edition','Edición',c=>ygoEditionValues(c)],
    ['archetype','Arquetipo',c=>ygoArchetypes(c)],
    ['language','Idioma',c=>c.language]
  ];

  // V44_MULTIGAME_FACET_CONTRACTS
  // Contratos explícitos: un campo NO aparece solo por existir en la API.
  function facetGameKey(){
    const g=norm(state.game||'').replace(/[\s_]+/g,'-');
    const aliases={
      'one-piece':'onepiece','onepiece-card-game':'onepiece',
      'pokemon-tcg':'pokemon','pkm':'pokemon',
      'yu-gi-oh':'ygo','yugioh':'ygo',
      'flesh-and-blood':'fab','flesh-and-blood-tcg':'fab',
      'disney-lorcana':'lorcana','lorcana-tcg':'lorcana',
      'star-wars-unlimited':'swu','starwarsunlimited':'swu',
      'digimon-card-game':'digimon',
      'gundam-card-game':'gundam',
      'dragon-ball-super-masters':'dbm','dbm':'dbm','dbs':'dbm',
      'dragon-ball-super-fusion-world':'dbfw','dbfw':'dbfw',
      'riftbound-tcg':'riftbound'
    };
    return aliases[g]||g;
  }

  function facetScalar(c,...paths){
    for(const p of paths){
      const parts=String(p).split('.');
      let v=c;
      for(const k of parts){v=v?.[k]}
      if(v!==undefined&&v!==null&&v!=='')return v;
    }
    return '';
  }

  function facetList(c,...paths){
    const v=facetScalar(c,...paths);
    if(Array.isArray(v))return v;
    if(v===undefined||v===null||v==='')return [];
    if(typeof v==='string' && /[;|]/.test(v))return v.split(/\s*[;|]\s*/);
    return [v];
  }

  function cleanFacetAtom(v){
    const s=String(v??'').replace(/\s+/g,' ').trim();
    if(!s)return '';
    if(/^(null|none|unknown|n\/a|na|undefined)$/i.test(s))return '';
    if(/^[.\-–—_·•/\\|]+$/.test(s))return '';
    return s;
  }

  function cleanFacetValues(raw){
    return [...new Set(values(raw).flatMap(v=>Array.isArray(v)?v:[v]).map(cleanFacetAtom).filter(Boolean))];
  }

  function genericCardType(c){return cleanFacetValues(facetList(c,'card_type','cardType','type','type_line','supertype','metadata.card_type','custom_attributes.cardType'));}

  function genericColors(c){return cleanFacetValues(facetList(c,'colors','color','ink','inks','aspects','aspect','metadata.color','custom_attributes.color','custom_attributes.colors','custom_attributes.aspect'));}

  function genericFinish(c){
    return cleanFacetValues(facetList(c,'finishes','finish','printing','treatment','variant','version','metadata.finish','metadata.printing'));
  }

  function genericTraits(c){
    return cleanFacetValues(facetList(c,'traits','trait','features','feature','keywords','tags','metadata.traits','custom_attributes.specialTrait'));
  }

  function genericClass(c){
    return cleanFacetValues(facetList(c,'class','classes','metadata.class','custom_attributes.class'));
  }

  function genericSubtype(c){
    return cleanFacetValues(facetList(c,'subtypes','subtype','card_subtype','cardSubType','metadata.subtypes','custom_attributes.cardSubType'));
  }

  function numericFacet(c,...paths){
    const v=facetScalar(c,...paths);
    if(v===undefined||v===null||v==='')return [];
    const n=Number(v);
    return Number.isFinite(n)?[String(n)]:[];
  }

  function pokemonVariant(c){
    const out=[];
    out.push(...facetList(c,'variant','variants','finish','finishes','printing'));
    const pv=c?.metadata?.pokemon_variant_prices;
    if(Array.isArray(pv))pv.forEach(x=>{if(x?.display_name)out.push(x.display_name)});
    return cleanFacetValues(out);
  }

  function lorcanaClassification(c){
    return cleanFacetValues(facetList(c,'classifications','classification','subtypes','subtype','metadata.classifications'));
  }

  function fabPitch(c){
    return cleanFacetValues(facetList(c,'pitch','pitch_value','pitchValue','metadata.pitch','custom_attributes.pitchValue'));
  }

  function swuAspects(c){
    return cleanFacetValues(facetList(c,'aspects','aspect','colors','color','metadata.aspects'));
  }

  function digimonLevel(c){
    return numericFacet(c,'level','lv','metadata.level');
  }

  function riftboundFaction(c){
    return cleanFacetValues(facetList(c,'faction','metadata.faction'));
  }

  // V48_GAME_FACET_HELPERS
  function pokemonStageValues(c){const raw=cleanFacetValues([...facetList(c,'subtypes','subtype','stage','custom_attributes.cardSubType'),...cardSubtypesOnly(c)]);return [...new Set(raw.map(v=>{const k=norm(v).replace(/[^a-z0-9]+/g,'');if(k==='pokemontool'||k==='tool')return'Tool';if(k==='pokemon')return'Pokémon';return v;}))];}
  function riftTypeValues(c){return cleanFacetValues(facetList(c,'card_type','type','type_line','metadata.card_type'));}
  function fabTypeValues(c){return cleanFacetValues([...facetList(c,'card_type','type','type_line','custom_attributes.cardType'),...facetList(c,'subtype','subtypes','custom_attributes.cardSubType')]);}
  function opTypeValues(c){return cleanFacetValues(facetList(c,'card_type','type','custom_attributes.cardType'));}
  function digimonCardTypeValues(c){return cleanFacetValues(facetList(c,'card_type','type','custom_attributes.cardType'));}
  function digimonTypeValues(c){return cleanFacetValues(facetList(c,'digimon_type','custom_attributes.digimonType'));}
  function digimonLevelValues(c){return cleanFacetValues(facetList(c,'level','lv','custom_attributes.levelLv'));}
  function numericFacetKey(k){return new Set(['rift_might','rift_cost','rift_energy','op_cost','digimon_level','swu_cost','gundam_cost','dbfw_cost']).has(k);}
  function facetValueCompare(k,a,b){if(numericFacetKey(k)){const x=Number(a),y=Number(b);if(Number.isFinite(x)&&Number.isFinite(y))return x-y;}return formatFacetValue(k,a).localeCompare(formatFacetValue(k,b),'es',{sensitivity:'base',numeric:true});}

  // V48B_SMART_FIELD_VALUES
  function smartFieldValues(c,...paths){
    const out=[];
    paths.forEach(path=>{
      const parts=String(path).split('.');
      let v=c;
      for(const k of parts){v=v?.[k]}
      if(v===undefined||v===null||v==='')return;
      const add=x=>{
        const s=String(x??'').trim();
        if(!s)return;
        if(/[;|]/.test(s))s.split(/\s*[;|]\s*/).forEach(y=>{if(y.trim())out.push(y.trim())});
        else out.push(s);
      };
      if(Array.isArray(v))v.forEach(add); else add(v);
    });
    return cleanFacetValues(out);
  }

  function pokemonStageClean(c){
    const vals=smartFieldValues(c,'subtypes','subtype','stage','metadata.stage','custom_attributes.cardSubType','custom_attributes.stage');
    const mapped=vals.map(v=>{
      const k=norm(v).replace(/[^a-z0-9]+/g,'');
      if(k==='pokemontool'||k==='tool')return 'Tool';
      return v;
    }).filter(v=>norm(v)!=='pokemon' && norm(v)!=='pokémon');
    return [...new Set(mapped)];
  }

  const fabTypeSmart=c=>smartFieldValues(c,'card_type','type','type_line','subtype','subtypes','custom_attributes.cardType','custom_attributes.cardSubType');
  const onePieceColor=c=>smartFieldValues(c,'color','colors','custom_attributes.color','custom_attributes.colors');
  const onePieceType=c=>smartFieldValues(c,'card_type','type','custom_attributes.cardType');
  const digimonColor=c=>smartFieldValues(c,'color','colors','custom_attributes.color');
  const digimonCardType=c=>smartFieldValues(c,'card_type','type','custom_attributes.cardType');
  const digimonLevel48=c=>smartFieldValues(c,'level','lv','custom_attributes.levelLv');
  const digimonSpecies=c=>smartFieldValues(c,'digimon_type','custom_attributes.digimonType');
  const swuAspect=c=>smartFieldValues(c,'aspect','aspects','custom_attributes.aspect');
  const swuType=c=>smartFieldValues(c,'card_type','type','custom_attributes.cardType');
  const dbColor=c=>smartFieldValues(c,'color','colors','custom_attributes.color');
  const dbType=c=>smartFieldValues(c,'card_type','type','custom_attributes.cardType');

  function numericFacetKey48(key){
    return new Set(['rift_might','rift_cost','rift_energy','fab_pitch','op_cost','digimon_level','swu_cost','gundam_cost','dbfw_cost']).has(key);
  }
  function facetCompare48(key,a,b){
    if(numericFacetKey48(key)){
      const na=Number(String(a).replace(/[^\d.-]/g,'')), nb=Number(String(b).replace(/[^\d.-]/g,''));
      if(Number.isFinite(na)&&Number.isFinite(nb)&&na!==nb)return na-nb;
    }
    return String(formatFacetValue(key,a)).localeCompare(String(formatFacetValue(key,b)),'es',{sensitivity:'base',numeric:true});
  }

  const facetContracts={
    mtg:[
      ['set','Expansión',c=>expansionFacetValue(c)],
      ['rarity','Rareza',c=>c.rarity],
      ['colors','Color',c=>cardColors(c)],
      ['types','Tipo',c=>cardTypesOnly(c)],
      ['subtypes','Subtipo',c=>cardSubtypesOnly(c)],
      ['cmc','Valor de maná (CMC)',c=>c.cmc??c.mana_value??null],
      ['color_count','Composición de color',c=>cardColors(c).includes('C')?'Incoloro':cardColors(c).length>1?'Multicolor':'Monocolor'],
      ['formats','Formato',c=>legalFormats(c)],
      ['finishes','Acabado',c=>c.finishes||c.finish],
      ['language','Idioma',c=>c.language],
      ['artist','Artista',c=>cardArtists(c)]
    ],
    pokemon:[
      ['set','Expansión',c=>expansionFacetValue(c)],
      ['rarity','Rareza',c=>c.rarity],
      ['pokemon_type','Tipo / Energía',c=>cleanFacetValues(facetList(c,'types','type'))],
      ['pokemon_stage','Etapa / Clase',c=>pokemonStageClean(c)],
      ['pokemon_variant','Variante',c=>pokemonVariant(c)],
      ['language','Idioma',c=>c.language],
      ['artist','Artista',c=>cardArtists(c)]
    ],
    ygo:ygoFacetDefs,
    onepiece:[
      ['set','Expansión',c=>expansionFacetValue(c)],
      ['rarity','Rareza',c=>c.rarity],
      ['colors','Color',c=>onePieceColor(c)],
      ['op_card_type','Tipo de carta',c=>onePieceType(c)],
      ['op_cost','Coste',c=>numericFacet(c,'cost','metadata.cost')],
      ['op_attribute','Atributo',c=>cleanFacetValues(facetList(c,'attribute','attributes','metadata.attribute'))],
      ['op_illustration','Tipo de ilustración',c=>smartFieldValues(c,'illustration_type','illustrationType','custom_attributes.illustrationType')],
      ['op_block','Block icon',c=>smartFieldValues(c,'block_icon','blockIcon','custom_attributes.blockIcon')],
      ['op_traits','Familia / Rasgo',c=>genericTraits(c)],
      ['op_finish','Versión / Acabado',c=>genericFinish(c)],
      ['language','Idioma',c=>c.language]
    ],
    lorcana:[
      ['set','Expansión',c=>expansionFacetValue(c)],
      ['rarity','Rareza',c=>c.rarity],
      ['lorcana_ink','Tinta',c=>genericColors(c)],
      ['lorcana_type','Tipo de carta',c=>genericCardType(c)],
      ['lorcana_class','Clasificación',c=>lorcanaClassification(c)],
      ['lorcana_cost','Coste',c=>numericFacet(c,'cost','ink_cost','metadata.cost')],
      ['lorcana_finish','Acabado / Versión',c=>genericFinish(c)],
      ['language','Idioma',c=>c.language],
      ['artist','Artista',c=>cardArtists(c)]
    ],
    fab:[
      ['set','Expansión',c=>expansionFacetValue(c)],
      ['rarity','Rareza',c=>c.rarity],
      ['fab_class','Clase',c=>cleanFacetValues(facetList(c,'class','classes','custom_attributes.class'))],
      ['fab_talent','Talento',c=>cleanFacetValues(facetList(c,'talent','talents','metadata.talent','custom_attributes.talent'))],
      ['fab_type','Tipo',c=>fabTypeSmart(c)],
      ['fab_subtype','Subtipo / Zona',c=>cleanFacetValues(facetList(c,'subtype','subtypes','custom_attributes.cardSubType'))],
      ['fab_pitch','Pitch',c=>cleanFacetValues(facetList(c,'pitch','pitch_value','pitchValue','custom_attributes.pitchValue'))],
      ['fab_finish','Acabado',c=>genericFinish(c)],
      ['language','Idioma',c=>c.language]
    ],
    riftbound:[
      ['set','Expansión',c=>expansionFacetValue(c)],
      ['rarity','Rareza',c=>c.rarity],
      ['rift_faction','Facción',c=>riftboundFaction(c)],
      ['rift_type','Tipo de carta',c=>riftTypeValues(c)],
      ['rift_cost','Coste',c=>numericFacet(c,'cost','stats.cost','metadata.cost')],
      ['rift_energy','Energía',c=>numericFacet(c,'energy','stats.energy','metadata.energy')],
      ['rift_might','Might',c=>numericFacet(c,'might','stats.might','metadata.might')],
      ['rift_keywords','Keyword',c=>cleanFacetValues(facetList(c,'keywords','tags','metadata.keywords'))],
      ['language','Idioma',c=>c.language]
    ],
    digimon:[
      ['set','Expansión',c=>expansionFacetValue(c)],
      ['rarity','Rareza',c=>c.rarity],
      ['digimon_color','Color',c=>digimonColor(c)],
      ['digimon_type','Tipo de carta',c=>digimonCardType(c)],
      ['digimon_level','Nivel',c=>digimonLevel48(c)],
      ['digimon_species','Tipo Digimon',c=>digimonTypeValues(c)],
      ['digimon_form','Forma',c=>cleanFacetValues(facetList(c,'form','forms','metadata.form'))],
      ['digimon_attribute','Atributo',c=>cleanFacetValues(facetList(c,'attribute','attributes','metadata.attribute'))],
      ['digimon_trait','Tipo / Rasgo',c=>genericTraits(c)],
      ['digimon_finish','Versión / Acabado',c=>genericFinish(c)],
      ['language','Idioma',c=>c.language]
    ],
    swu:[
      ['set','Expansión',c=>expansionFacetValue(c)],
      ['rarity','Rareza',c=>c.rarity],
      ['swu_aspect','Aspecto',c=>swuAspect(c)],
      ['swu_type','Tipo de carta',c=>swuType(c)],
      ['swu_traits','Traits',c=>genericTraits(c)],
      ['swu_arena','Arena',c=>cleanFacetValues(facetList(c,'arena','arenas','metadata.arena'))],
      ['swu_cost','Coste',c=>numericFacet(c,'cost','metadata.cost')],
      ['swu_treatment','Tratamiento',c=>genericFinish(c)],
      ['language','Idioma',c=>c.language]
    ],
    gundam:[
      ['set','Expansión',c=>expansionFacetValue(c)],
      ['rarity','Rareza',c=>c.rarity],
      ['gundam_color','Color',c=>smartFieldValues(c,'color','colors','custom_attributes.color')],
      ['gundam_type','Tipo de carta',c=>smartFieldValues(c,'card_type','type','custom_attributes.cardType')],
      ['gundam_cost','Coste',c=>numericFacet(c,'cost','level','metadata.cost')],
      ['gundam_trait','Rasgo / Serie',c=>smartFieldValues(c,'traits','trait','series','custom_attributes.traits','custom_attributes.series')],
      ['gundam_version','Versión',c=>genericFinish(c)],
      ['language','Idioma',c=>c.language]
    ],
    dbm:[
      ['set','Expansión',c=>expansionFacetValue(c)],
      ['rarity','Rareza',c=>c.rarity],
      ['dbs_color','Color',c=>dbColor(c)],
      ['dbs_type','Tipo de carta',c=>dbType(c)],
      ['dbs_trait','Special Trait',c=>smartFieldValues(c,'specialTrait','custom_attributes.specialTrait')],
      ['dbs_era','Saga / Era',c=>smartFieldValues(c,'era','metadata.era','custom_attributes.era')],
      ['dbs_character','Personaje',c=>smartFieldValues(c,'character','metadata.character','custom_attributes.character')],
      ['dbs_finish','Versión / Acabado',c=>genericFinish(c)],
      ['language','Idioma',c=>c.language]
    ],
    dbfw:[
      ['set','Expansión',c=>expansionFacetValue(c)],
      ['rarity','Rareza',c=>c.rarity],
      ['dbfw_color','Color',c=>dbColor(c)],
      ['dbfw_type','Tipo de carta',c=>dbType(c)],
      ['dbfw_character','Rasgo / Personaje',c=>smartFieldValues(c,'character','characterTraits','custom_attributes.character','custom_attributes.characterTraits')],
      ['dbfw_cost','Coste',c=>numericFacet(c,'cost','energy_cost','metadata.cost')],
      ['dbfw_finish','Versión / Acabado',c=>genericFinish(c)],
      ['language','Idioma',c=>c.language]
    ]
  };

  function activeFacetDefs(){
    return facetContracts[facetGameKey()] || [
      ['set','Expansión',c=>expansionFacetValue(c)],
      ['rarity','Rareza',c=>c.rarity],
      ['language','Idioma',c=>c.language]
    ];
  }

  const facetDefs=[
    ['set','Expansión',c=>expansionFacetValue(c)],
    ['rarity','Rareza',c=>rarityValues(c)],
    ['colors','Color',c=>cardColors(c)],
    ['types','Tipo',c=>cardTypesOnly(c)],
    ['subtypes','Subtipo',c=>cardSubtypesOnly(c)],
    ['artist','Artista',c=>cardArtists(c)],
    ['language','Idioma',c=>c.language],
    ['finishes','Acabado',c=>c.finishes||c.finish],
    ['formats','Formato',c=>legalFormats(c)],
    ['attribute','Atributo',c=>c.attribute],
    ['faction','Facción',c=>c.faction],
    ['race','Raza / Clase',c=>c.race||c.classes],
    ['traits','Traits',c=>c.traits||c.subtypes]
  ];

  const values=v=>Array.isArray(v)?v:(v==null||v===''?[]:[v]);

  function formatFacetValue(key,v){
    const raw=String(v);
    const colorMap={
      W:'Blanco',U:'Azul',B:'Negro',R:'Rojo',G:'Verde',C:'Incoloro',
      w:'Blanco',u:'Azul',b:'Negro',r:'Rojo',g:'Verde',c:'Incoloro',
      white:'Blanco',blue:'Azul',black:'Negro',red:'Rojo',green:'Verde',
      colorless:'Incoloro',colourless:'Incoloro',incoloro:'Incoloro'
    };
    if(key==='colors'&&colorMap[raw])return colorMap[raw];
    if(key==='colors'&&colorMap[raw.toLowerCase()])return colorMap[raw.toLowerCase()];

    const lang={en:'Inglés',es:'Español',fr:'Francés',de:'Alemán',it:'Italiano',pt:'Portugués',ja:'Japonés',jp:'Japonés',ko:'Coreano',kr:'Coreano',zh:'Chino',cs:'Chino simplificado',zhs:'Chino simplificado',ct:'Chino tradicional',zht:'Chino tradicional',ru:'Ruso',he:'Hebreo',la:'Latín',gr:'Griego antiguo',ar:'Árabe',sa:'Sánscrito',ph:'Pirexiano'};
    if(key==='language'&&lang[raw.toLowerCase()])return lang[raw.toLowerCase()];
    if(key==='set')return raw;
    if(key==='finishes')return finishLabel(raw);

    if(state.game==='ygo'){
      // V48_YGO_CARD_TYPE_LABEL
      if(key==='ygo_card_type')return raw==='Mágica'?'Mágica':raw;
      if(key==='rarity'){
        const k=norm(raw).replace(/[\\s_-]+/g,'');
        if(ygoRarityLabels[k])return ygoRarityLabels[k];
      }
      if(key==='ygo_edition')return raw;
      if(key==='attribute')return raw.toUpperCase();
    }

    if(state.game==='pokemon'){
      const k=norm(raw).replace(/[\s_-]+/g,'');
      if((key==='types'||key==='subtypes')&&k==='pokemon')return 'Pokémon';
      if(key==='subtypes'&&k==='pokemontool')return 'Pokémon Tool';
      if(key==='subtypes'&&k==='pokemonex')return 'Pokémon ex';
      if(key==='subtypes'&&k==='pokemonv')return 'Pokémon V';
      if(key==='subtypes'&&k==='pokemonvmax')return 'Pokémon VMAX';
      if(key==='subtypes'&&k==='pokemonvstar')return 'Pokémon VSTAR';
      if(key==='subtypes'&&k==='stage1')return 'Stage 1';
      if(key==='subtypes'&&k==='stage2')return 'Stage 2';
    }

    const g=facetGameKey();
    const rarityMaps={
      onepiece:{c:'Common',uc:'Uncommon',r:'Rare',sr:'Super Rare',sec:'Secret Rare',l:'Leader',sp:'Special'},
      digimon:{c:'Common',u:'Uncommon',r:'Rare',sr:'Super Rare',sec:'Secret Rare',p:'Promo'},
      gundam:{c:'Common',u:'Uncommon',r:'Rare',sr:'Super Rare',lr:'Legend Rare'},
      dbsm:{c:'Common',uc:'Uncommon',r:'Rare',sr:'Super Rare',spr:'Special Rare',scr:'Secret Rare',pr:'Promo'},
      dbsfw:{c:'Common',uc:'Uncommon',r:'Rare',sr:'Super Rare',l:'Leader',scr:'Secret Rare',pr:'Promo'}
    };
    if(key==='rarity' && rarityMaps[g]){
      const rk=norm(raw).replace(/[\s_-]+/g,'');
      if(rarityMaps[g][rk])return rarityMaps[g][rk];
    }

    return titleCase(raw);
  }

  function availableFacetsFor(cards){
    const defs=activeFacetDefs().map(([key,label,getter])=>{
      const vals=cleanFacetValues(cards.flatMap(c=>values(getter(c))))
        .sort((a,b)=>facetCompare48(key,a,b));
      return {key,label,getter,vals};
    }).filter(f=>f.vals.length>1 && (f.key==='set' || f.key==='artist' || (state.game==='mtg'&&f.key==='subtypes') || f.vals.length<=60));

    const signature=f=>f.vals.map(v=>norm(v)).sort().join('|');
    const groups=new Map();
    defs.forEach(f=>{
      const sig=signature(f);
      if(!groups.has(sig))groups.set(sig,[]);
      groups.get(sig).push(f);
    });

    return defs.filter(f=>{
      const sig=signature(f);
      const siblings=groups.get(sig)||[];
      if(siblings.length<2)return true;
      if(siblings.some(x=>x.key==='types'))return f.key==='types';
      return siblings[0]===f;
    });
  }

  function renderSearchFilters(){
    updateClearFilterLabels();
    const host=q(root,'[data-btcg-search-filter-groups]');
    const defs=availableFacetsFor(state.searchResults);

    const stockKnown=state.searchResults.some(c=>stockOf(c)!==null);
    const stockInput=q(root,'[data-btcg-search-stock-only]');
    stockInput.disabled=!stockKnown;
    stockInput.closest('.btcg-stock-filter').classList.toggle('is-disabled',!stockKnown);
    stockInput.closest('.btcg-stock-filter').title=stockKnown?'':'Se activará al conectar disponibilidad de Shopify';

    if(!defs.length){
      host.innerHTML='<p class="btcg-filters__empty">No hay filtros adicionales disponibles.</p>';
      return;
    }

    host.innerHTML=defs.map(f=>{
      const selected=(state.searchFacets[f.key]||[]).length;
      return `<details class="btcg-filter-group" ${selected?'open':''}>
      <summary>
        <span class="btcg-filter-group__title">${esc(f.label)}${selected?` <em class="btcg-filter-active-count">(${selected})</em>`:''}</span>
        <span class="btcg-filter-group__toggle" aria-hidden="true"><svg class="btcg-filter-hand-sign btcg-filter-hand-sign--plus" viewBox="0 0 28 26"><path class="main" d="M3.8 13.0 C8.0 12.1 13.5 13.5 23.8 12.3 M14.2 3.8 C13.1 8.0 14.6 14.1 13.5 22.2"/><path class="dry" d="M4.6 14.2 C10.0 13.1 16.2 14.0 23.0 13.4 M15.3 4.6 C14.2 10.0 15.1 16.0 14.5 21.4"/></svg><svg class="btcg-filter-hand-sign btcg-filter-hand-sign--minus" viewBox="0 0 28 26"><path class="main" d="M3.8 13.0 C8.0 12.1 13.5 13.5 23.8 12.3"/><path class="dry" d="M4.6 14.2 C10.0 13.1 16.2 14.0 23.0 13.4"/></svg></span>
      </summary>
      ${f.key==='subtypes'?'<input type="search" data-subtype-find placeholder="Buscar subtipo…" aria-label="Buscar subtipo" style="width:100%;padding:8px;margin:8px 0">':''}
      <div class="btcg-filter-group__scroll">
        ${(f.key==='subtypes'?f.vals:f.key==='set'?f.vals.slice(0,250):f.vals.slice(0,40)).map(v=>{
          const on=(state.searchFacets[f.key]||[]).includes(v);
          return `<label>
            <input type="checkbox" data-search-facet="${esc(f.key)}" value="${esc(v)}" ${on?'checked':''}>
            <span>${esc(formatFacetValue(f.key,v))}</span>
          </label>`;
        }).join('')}
      </div>
    </details>`;
    }).join('');

    qa(host,'[data-subtype-find]').forEach(input=>input.addEventListener('input',()=>{qa(input.closest('details'),'label').forEach(label=>{label.hidden=!norm(label.textContent).includes(norm(input.value));});}));
    qa(host,'[data-search-facet]').forEach(inp=>inp.addEventListener('change',()=>{
      const key=inp.dataset.searchFacet;
      state.searchFacets[key]=state.searchFacets[key]||[];

      if(inp.checked){
        if(!state.searchFacets[key].includes(inp.value))state.searchFacets[key].push(inp.value);
      }else{
        state.searchFacets[key]=state.searchFacets[key].filter(v=>v!==inp.value);
      }

      if(!state.searchFacets[key].length)delete state.searchFacets[key];
      renderSearchResults();
    }));
  }

  function passesSearchFacets(c){
    if(state.searchStockOnly&&stockOf(c)!==true)return false;

    return Object.entries(state.searchFacets).every(([key,selected])=>{
      const def=activeFacetDefs().find(d=>d[0]===key);
      if(!def)return true;
      const cv=values(def[2](c)).map(String);
      if(browse.active&&state.game==='mtg'&&key==='colors'){
        const exact=q(root,'[data-browse-color-mode]')?.value==='exact';
        return selected.every(v=>cv.includes(v))&&(!exact||cv.length===selected.length);
      }
      return selected.some(v=>cv.includes(v));
    });
  }

  function selectedFilterCount(facets,stockOnly){
    return Object.values(facets||{}).reduce((sum,vals)=>sum+(Array.isArray(vals)?vals.length:0),0)+(stockOnly?1:0);
  }

  function updateClearFilterLabels(){
    const searchBtn=q(root,'[data-btcg-search-clear-filters]');
    if(searchBtn){
      const n=selectedFilterCount(state.searchFacets,state.searchStockOnly);
      searchBtn.textContent=n?`Limpiar filtros (${n})`:'Limpiar filtros';
    }
    const setBtn=q(root,'[data-btcg-clear-filters]');
    if(setBtn){
      const n=selectedFilterCount(state.facets,state.stockOnly);
      setBtn.textContent=n?`Limpiar filtros (${n})`:'Limpiar filtros';
    }
  }

  function renderSearchActiveFilters(){
    updateClearFilterLabels();
    const host=q(root,'[data-btcg-search-active-filters]');
    const chips=Object.entries(state.searchFacets).flatMap(([k,vs])=>
      vs.map(v=>`<button type="button" data-remove-search-facet="${esc(k)}" data-value="${esc(v)}">${esc(formatFacetValue(k,v))}<span class="btcg-chip-x" aria-hidden="true">${handXSvg()}</span></button>`)
    );
    if(state.searchStockOnly)chips.unshift(`<button type="button" data-remove-search-stock>En stock<span class="btcg-chip-x" aria-hidden="true">${handXSvg()}</span></button>`);
    host.innerHTML=chips.join('');

    qa(host,'[data-remove-search-facet]').forEach(b=>b.addEventListener('click',()=>{
      const k=b.dataset.removeSearchFacet;
      state.searchFacets[k]=(state.searchFacets[k]||[]).filter(v=>v!==b.dataset.value);
      if(!state.searchFacets[k].length)delete state.searchFacets[k];
      renderSearchFilters();
      renderSearchResults();
    }));

    const rs=q(host,'[data-remove-search-stock]');
    if(rs)rs.addEventListener('click',()=>{
      state.searchStockOnly=false;
      q(root,'[data-btcg-search-stock-only]').checked=false;
      renderSearchResults();
    });
  }

  function renderSearchResults(){
    if(browse.active){browse.page=1;renderBrowseResults();return;}
    const rows=state.searchResults.filter(passesSearchFacets);
    q(root,'[data-btcg-result-count]').textContent=rows.length?`${rows.length} impresiones`:'0 impresiones';
    renderSearchActiveFilters();

    const host=q(root,'[data-btcg-search-results]');
    host.innerHTML=rows.length
      ?rows.map(c=>searchPrintingHtml(c)).join('')
      :'<div class="btcg__empty-state"><strong>No hay impresiones con estos filtros.</strong></div>';

    attachCardZoom(host,rows);
  }

  function availableFacets(){
    return availableFacetsFor(state.cards);
  }

  function buildFilters(){renderFilters();}

  function renderFilters(){
    updateClearFilterLabels();
    const host=q(root,'[data-btcg-filter-groups]');
    const defs=availableFacets();

    const stockKnown=state.cards.some(c=>stockOf(c)!==null);
    const stockInput=q(root,'[data-btcg-stock-only]');
    stockInput.disabled=!stockKnown;
    stockInput.closest('.btcg-stock-filter').classList.toggle('is-disabled',!stockKnown);
    stockInput.closest('.btcg-stock-filter').title=stockKnown?'':'Se activará al conectar disponibilidad de Shopify';

    if(!defs.length){
      host.innerHTML='<p class="btcg-filters__empty">No hay filtros adicionales disponibles.</p>';
      return;
    }

    host.innerHTML=defs.map(f=>{
      const selected=(state.facets[f.key]||[]).length;
      return `<details class="btcg-filter-group" ${selected?'open':''}>
      <summary>
        <span class="btcg-filter-group__title">${esc(f.label)}${selected?` <em class="btcg-filter-active-count">(${selected})</em>`:''}</span>
        <span class="btcg-filter-group__toggle" aria-hidden="true"><svg class="btcg-filter-hand-sign btcg-filter-hand-sign--plus" viewBox="0 0 28 26"><path class="main" d="M3.8 13.0 C8.0 12.1 13.5 13.5 23.8 12.3 M14.2 3.8 C13.1 8.0 14.6 14.1 13.5 22.2"/><path class="dry" d="M4.6 14.2 C10.0 13.1 16.2 14.0 23.0 13.4 M15.3 4.6 C14.2 10.0 15.1 16.0 14.5 21.4"/></svg><svg class="btcg-filter-hand-sign btcg-filter-hand-sign--minus" viewBox="0 0 28 26"><path class="main" d="M3.8 13.0 C8.0 12.1 13.5 13.5 23.8 12.3"/><path class="dry" d="M4.6 14.2 C10.0 13.1 16.2 14.0 23.0 13.4"/></svg></span>
      </summary>
      <div class="btcg-filter-group__scroll">
        ${f.vals.slice(0,40).map(v=>{
          const on=(state.facets[f.key]||[]).includes(v);
          return `<label>
            <input type="checkbox" data-facet="${esc(f.key)}" value="${esc(v)}" ${on?'checked':''}>
            <span>${esc(formatFacetValue(f.key,v))}</span>
          </label>`;
        }).join('')}
      </div>
    </details>`;
    }).join('');

    qa(host,'[data-facet]').forEach(inp=>inp.addEventListener('change',()=>{
      const key=inp.dataset.facet;
      state.facets[key]=state.facets[key]||[];

      if(inp.checked){
        if(!state.facets[key].includes(inp.value))state.facets[key].push(inp.value);
      }else{
        state.facets[key]=state.facets[key].filter(v=>v!==inp.value);
      }

      if(!state.facets[key].length)delete state.facets[key];
      renderCards();
    }));
  }

  function passesFacets(c){
    if(state.stockOnly&&stockOf(c)!==true)return false;

    return Object.entries(state.facets).every(([key,selected])=>{
      const def=activeFacetDefs().find(d=>d[0]===key);
      if(!def)return true;
      const cv=values(def[2](c)).map(String);
      return selected.some(v=>cv.includes(v));
    });
  }

  function renderActiveFilters(){
    updateClearFilterLabels();
    const host=q(root,'[data-btcg-active-filters]');
    const chips=Object.entries(state.facets).flatMap(([k,vs])=>vs.map(v=>`<button type="button" data-remove-facet="${esc(k)}" data-value="${esc(v)}">${esc(formatFacetValue(k,v))}<span class="btcg-chip-x" aria-hidden="true">${handXSvg()}</span></button>`));
    if(state.stockOnly)chips.unshift(`<button type="button" data-remove-stock>En stock<span class="btcg-chip-x" aria-hidden="true">${handXSvg()}</span></button>`);
    host.innerHTML=chips.join('');

    qa(host,'[data-remove-facet]').forEach(b=>b.addEventListener('click',()=>{
      const k=b.dataset.removeFacet;
      state.facets[k]=(state.facets[k]||[]).filter(v=>v!==b.dataset.value);
      if(!state.facets[k].length)delete state.facets[k];
      renderFilters();renderCards();
    }));

    const rs=q(host,'[data-remove-stock]');
    if(rs)rs.addEventListener('click',()=>{
      state.stockOnly=false;q(root,'[data-btcg-stock-only]').checked=false;renderCards();
    });
  }

  function naturalCollectorValue(c){
    const raw=collector(c);
    const m=String(raw).match(/(\d+)/);
    return m?Number(m[1]):Number.MAX_SAFE_INTEGER;
  }

  function moneyNumber(value){
    if(value&&typeof value==='object')value=value.amount??value.value??value.price;
    if(value==null||value==='')return null;
    const direct=Number(value);
    if(Number.isFinite(direct))return direct;
    const m=String(value).replace(/,/g,'').match(/-?\d+(?:\.\d+)?/);
    return m?Number(m[0]):null;
  }

  function priceOf(c){
    const commercePrice=moneyNumber(c?._commerce?.min_price);
    if(commercePrice!=null)return commercePrice;
    const variants=Array.isArray(c?._commerce?.variants)?c._commerce.variants:[];
    const live=variants.filter(v=>Number(v?.inventory||0)>0).map(v=>moneyNumber(v?.price)).filter(v=>v!=null);
    if(live.length)return Math.min(...live);
    for(const k of ['price','market_price','shopify_price','burro_price']){
      const n=moneyNumber(c?.[k]);
      if(n!=null)return n;
    }
    return null;
  }

  function commerceSummaryHtml(c){
    /* 064: la capa comercial interactiva ya muestra precio, stock y variante.
       Evitamos repetir “Desde …” y el resumen de variantes para ahorrar espacio. */
    return '';
  }

  function commerceHtml(c){
    const known=stockOf(c);
    const price=priceOf(c);
    const url=productUrlOf(c);
    if(known===false){
      const priceText=price==null?'—':`$${price.toFixed(2)}`;
      return `<div class="btcg-card__price">${esc(priceText)}</div><small>No disponible</small><button type="button" disabled>Agregar</button>`;
    }
    if(known!==true){
      return `<div class="btcg-card__price">—</div><small>No disponible</small><button type="button" disabled>Agregar</button>`;
    }

    const variants=liveVariantsOf(c);
    if(!variants.length){
      return `<div class="btcg-card__price">${price==null?'—':`$${price.toFixed(2)}`}</div><small>No disponible</small><button type="button" disabled>Agregar</button>`;
    }

    const options=variants.map((v,i)=>{
      const vp=moneyNumber(v?.price);
      return `<option value="${esc(shopifyVariantId(v))}" data-stock="${Number(v.inventory||0)}" data-price="${vp==null?'':vp.toFixed(2)}" ${i===0?'selected':''}>${esc(variantLabel(v))}</option>`;
    }).join('');
    const first=variants[0];
    const firstPrice=moneyNumber(first?.price)??price;
    const firstStock=Math.max(1,Number(first?.inventory||1));
    const cardKey=`${setCode(c)}-${collector(c)}`.replace(/[^a-z0-9_-]/gi,'-');

    return `<div class="btcg-commerce-price-row" style="display:flex;align-items:baseline;gap:8px;flex-wrap:wrap">
        <div class="btcg-card__price" data-commerce-price>${firstPrice==null?'—':`$${firstPrice.toFixed(2)}`}</div>
        <small data-commerce-stock>Disponible · ${firstStock}</small>
      </div>
      <label class="btcg-commerce-variant" style="display:grid;gap:4px;margin-top:7px;font-size:11px;text-align:left">
        <span style="font-weight:700">Variante</span>
        <select data-commerce-variant aria-label="Seleccionar variante ${esc(c.name||'carta')}" style="max-width:100%;min-height:34px">${options}</select>
      </label>
      <div class="btcg-commerce-actions" style="display:flex;gap:6px;align-items:center;margin-top:7px">
        <input type="number" data-commerce-qty min="1" max="${firstStock}" value="1" inputmode="numeric" aria-label="Cantidad" style="width:58px;min-height:36px">
        <button type="button" data-commerce-add data-card-key="${esc(cardKey)}">Agregar</button>
      </div>
      <small data-commerce-message aria-live="polite" style="display:block;margin-top:5px"></small>`;
  }

  // V48B_COLLECTOR_GROUP_SORT
  function collectorClean48(c){
    return String((typeof cleanCollectorDisplay==='function'?cleanCollectorDisplay(c):collector(c))||'').trim().toUpperCase();
  }
  function opPrefix48(raw){
    const m=String(raw||'').match(/^([A-Z]{2,5}\d{1,3})-(\d+)/);
    return m?{prefix:m[1],num:Number(m[2])}:null;
  }
  function dominantOpPrefix48(rows){
    const counts=new Map();
    rows.forEach(c=>{const p=opPrefix48(collectorClean48(c));if(p)counts.set(p.prefix,(counts.get(p.prefix)||0)+1)});
    return [...counts.entries()].sort((a,b)=>b[1]-a[1]||a[0].localeCompare(b[0],undefined,{numeric:true}))[0]?.[0]||'';
  }
  function collectorKey48(c,primaryOp=''){
    const raw=collectorClean48(c);
    if(state.game==='riftbound'){
      let m=raw.match(/^(\d+)\/(\d+)$/); if(m)return[0,Number(m[1]),0,raw];
      m=raw.match(/^R(\d+)$/); if(m)return[1,Number(m[1]),0,raw];
      m=raw.match(/^SP(\d+)(?:\/(\d+))?$/); if(m)return[2,Number(m[1]),Number(m[2]||0),raw];
      return[3,0,0,raw];
    }
    if(state.game==='onepiece'){
      const p=opPrefix48(raw);
      if(p){
        if(primaryOp&&p.prefix===primaryOp)return[0,p.num,0,raw];
        return[1,Number((p.prefix.match(/(\d+)$/)||[])[1]||999),p.num,raw];
      }
      return[2,0,0,raw];
    }
    const p=opPrefix48(raw);
    if(p)return[0,Number((p.prefix.match(/(\d+)$/)||[])[1]||0),p.num,raw];
    const n=Number((raw.match(/(\d+)/)||[])[1]||999999);
    return[0,n,0,raw];
  }
  function compareCollector48(a,b,primaryOp=''){
    const A=collectorKey48(a,primaryOp),B=collectorKey48(b,primaryOp);
    for(let i=0;i<3;i++)if(A[i]!==B[i])return A[i]-B[i];
    return String(A[3]).localeCompare(String(B[3]),undefined,{numeric:true,sensitivity:'base'});
  }

  function sortCards(list){
    const rows=list.slice();

    if(state.sort==='collector_asc'){
      const primary=state.game==='onepiece'?dominantOpPrefix48(rows):'';
      return rows.sort((a,b)=>compareCollector48(a,b,primary));
    }
    if(state.sort==='collector_desc'){
      const primary=state.game==='onepiece'?dominantOpPrefix48(rows):'';
      return rows.sort((a,b)=>compareCollector48(b,a,primary));
    }
    if(state.sort==='name_asc'){
      return rows.sort((a,b)=>String(a.name||'').localeCompare(String(b.name||''),'es',{sensitivity:'base'}));
    }
    if(state.sort==='name_desc'){
      return rows.sort((a,b)=>String(b.name||'').localeCompare(String(a.name||''),'es',{sensitivity:'base'}));
    }
    if(state.sort==='price_asc'){
      return rows.sort((a,b)=>(priceOf(a)??Number.MAX_SAFE_INTEGER)-(priceOf(b)??Number.MAX_SAFE_INTEGER));
    }
    if(state.sort==='price_desc'){
      return rows.sort((a,b)=>(priceOf(b)??-1)-(priceOf(a)??-1));
    }
    return rows;
  }

  function renderCards(){
    const rawTerm=String(setSearch.value||'').trim();
    const term=norm(rawTerm);
    const cq=collectorQuery(rawTerm);
    const filtered=state.cards.filter(c=>{
      const textMatch=!term||norm(c.name||'').includes(term);
      const numberMatch=cq&&collectorMatches(c,cq);
      return (textMatch||numberMatch)&&passesFacets(c);
    });
    const list=sortCards(filtered);

    q(root,'[data-btcg-set-count]').textContent=`${list.length} cartas`;
    renderActiveFilters();

    const host=q(root,'[data-btcg-cards]');
    host.innerHTML=list.map(c=>cardHtml(c)).join('');
    attachCardZoom(host,list);
  }

  function cardHtml(c){
    const img=frontImage(c);

    return `<article class="btcg-card" data-can-flip="${canFlipCard(c)?'1':'0'}" data-has-back="${backImage(c)?'1':'0'}">
      <div class="btcg-card__media">
        <button class="btcg-card__image-button" type="button" data-zoom-card>
          <span class="btcg-card__image-wrap">
            ${img?`<img class="btcg-card__image" src="${esc(img)}" width="488" height="680" loading="lazy" alt="${esc(faceName(c,0)||c.name||'Carta')}">`:''}
          </span>
        </button>
        ${canFlipCard(c)&&backImage(c)?`<button class="btcg-card__flip-inline" type="button" data-flip-inline aria-label="Ver reverso" title="Ver reverso">${handRotateSvg()}</button>`:''}
      </div>

      <div class="btcg-card__body">
        <div class="btcg-card__info">
          <strong>${productNameHtml(c)}</strong>
          <small>${cardReferenceHtml(c,state.setCode,{search:false})}</small>

          <div class="btcg-card__list-extra">
            <small><b>Rareza:</b> ${esc(displayRarities(c))}</small>
            <small><b>Tipo:</b> <span data-card-face-type>${esc(faceType(c,0)||c.type_line||c.card_type||displayCardTypes(c))}</span></small>
            <small><b>Artista:</b> ${esc(c.artist||c.illustrator||'—')}</small>
          </div>
          ${commerceSummaryHtml(c)}
        </div>

        <div class="btcg-card__commerce">
          ${commerceHtml(c)}
        </div>
      </div>
    </article>`;
  }

  function warmBackImage(card){
    const back=backImage(card);
    if(!back||card.__backWarmed)return;
    card.__backWarmed=true;
    const preload=new Image();
    preload.decoding='async';
    preload.src=back;
  }

  function updateCommerceControls(cardEl){
    const select=cardEl.querySelector('[data-commerce-variant]');
    if(!select)return;
    const opt=select.options[select.selectedIndex];
    const stock=Math.max(0,Number(opt?.dataset?.stock||0));
    const price=Number(opt?.dataset?.price);
    const qty=cardEl.querySelector('[data-commerce-qty]');
    const priceEl=cardEl.querySelector('[data-commerce-price]');
    const stockEl=cardEl.querySelector('[data-commerce-stock]');
    const add=cardEl.querySelector('[data-commerce-add]');
    if(priceEl)priceEl.textContent=Number.isFinite(price)?`$${price.toFixed(2)}`:'—';
    if(stockEl)stockEl.textContent=stock>0?`Disponible · ${stock}`:'Agotado';
    if(qty){
      qty.max=String(Math.max(1,stock));
      if(Number(qty.value||1)>stock)qty.value=String(Math.max(1,stock));
      qty.disabled=stock<=0;
    }
    if(add)add.disabled=stock<=0;
  }

  function cartSectionIds(){
    const ids=new Set();
    const candidates=[
      document.querySelector('cart-drawer'),
      document.querySelector('#CartDrawer'),
      document.querySelector('[data-cart-drawer]'),
      document.querySelector('.cart-drawer'),
      document.querySelector('[href="/cart"]'),
      document.querySelector('[data-cart-icon-bubble]'),
      document.querySelector('#cart-icon-bubble')
    ].filter(Boolean);
    candidates.forEach(el=>{
      const section=el.closest?.('[id^="shopify-section-"]');
      if(section?.id)ids.add(section.id.replace(/^shopify-section-/,''));
    });
    return [...ids];
  }

  async function refreshThemeCart(){
    const ids=cartSectionIds();
    if(ids.length){
      try{
        const r=await fetch(`/?sections=${encodeURIComponent(ids.join(','))}`,{headers:{Accept:'application/json'},cache:'no-store'});
        if(r.ok){
          const sections=await r.json();
          ids.forEach(id=>{
            const current=document.getElementById(`shopify-section-${id}`);
            const html=sections?.[id];
            if(!current||!html)return;
            const tmp=document.createElement('div');tmp.innerHTML=html;
            const fresh=tmp.querySelector(`#shopify-section-${CSS.escape(id)}`)||tmp.firstElementChild;
            if(fresh)current.innerHTML=fresh.innerHTML;
          });
        }
      }catch(e){console.warn('[TCG Singles cart sections]',e);}
    }
    document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true,detail:{source:'tcg-singles'}}));
    document.dispatchEvent(new CustomEvent('cart:updated',{bubbles:true,detail:{source:'tcg-singles'}}));
    window.dispatchEvent(new CustomEvent('cart:refresh',{detail:{source:'tcg-singles'}}));
  }

  const commerceCartLocks=new Set();

  async function readCartNow(){
    const r=await fetch(`/cart.js?ts=${Date.now()}`,{
      headers:{Accept:'application/json','Cache-Control':'no-cache'},
      cache:'no-store',
      credentials:'same-origin'
    });
    if(!r.ok)throw new Error(`CART_HTTP_${r.status}`);
    return r.json();
  }

  async function currentVariantInCart(variantId){
    try{
      const cart=await readCartNow();
      return (cart.items||[]).filter(item=>String(item.variant_id||item.id)===String(variantId)).reduce((n,item)=>n+Number(item.quantity||0),0);
    }catch(e){return 0;}
  }

  async function enforceVariantCartLimit(variantId,stock){
    try{
      const cart=await readCartNow();
      const matches=(cart.items||[]).filter(item=>String(item.variant_id||item.id)===String(variantId));
      let total=matches.reduce((n,item)=>n+Number(item.quantity||0),0);
      if(total<=stock)return total;

      let remaining=Math.max(0,stock);
      for(const item of matches){
        const keep=Math.min(Number(item.quantity||0),remaining);
        remaining=Math.max(0,remaining-keep);
        if(keep!==Number(item.quantity||0)){
          const r=await fetch('/cart/change.js',{
            method:'POST',
            headers:{Accept:'application/json','Content-Type':'application/json'},
            credentials:'same-origin',
            body:JSON.stringify({id:item.key||item.id,quantity:keep})
          });
          if(!r.ok)throw new Error(`CART_CHANGE_${r.status}`);
        }
      }
      return stock;
    }catch(e){
      console.warn('[TCG Singles cart limit]',e);
      return null;
    }
  }

  async function syncCartLimit(cardEl){
    const select=cardEl.querySelector('[data-commerce-variant]');
    const qty=cardEl.querySelector('[data-commerce-qty]');
    const add=cardEl.querySelector('[data-commerce-add]');
    const message=cardEl.querySelector('[data-commerce-message]');
    if(!select||!qty||!add)return;
    const opt=select.options[select.selectedIndex];
    const stock=Math.max(0,Number(opt?.dataset?.stock||0));
    const id=String(select.value||'').trim();
    const already=await currentVariantInCart(id);
    const remaining=Math.max(0,stock-already);
    qty.max=String(Math.max(1,remaining));
    qty.disabled=remaining<=0;
    add.disabled=remaining<=0;
    if(remaining<=0){
      if(message)message.textContent=`Máximo en carrito (${already}/${stock}).`;
    }else if(already>0){
      if(message)message.textContent=`En carrito: ${already} · quedan ${remaining}.`;
      if(Number(qty.value||1)>remaining)qty.value=String(remaining);
    }else if(message && /^(Ya tienes|Máximo en carrito|En carrito:)/.test(message.textContent||'')){
      message.textContent='';
    }
  }

  async function addCommerceToCart(cardEl){
    const select=cardEl.querySelector('[data-commerce-variant]');
    const qtyInput=cardEl.querySelector('[data-commerce-qty]');
    const add=cardEl.querySelector('[data-commerce-add]');
    const message=cardEl.querySelector('[data-commerce-message]');
    if(!select||!add)return;
    const opt=select.options[select.selectedIndex];
    const id=String(select.value||'').trim();
    const stock=Math.max(0,Number(opt?.dataset?.stock||0));
    if(!id)return;

    /* Bloqueo por variante: evita dos clics simultáneos o repetidos antes de leer el carrito actualizado. */
    if(commerceCartLocks.has(id)){
      if(message)message.textContent='Esta variante ya se está agregando…';
      return;
    }
    commerceCartLocks.add(id);

    const previous=add.textContent;
    add.disabled=true;
    add.textContent='Agregando…';
    if(message)message.textContent='';

    try{
      const already=await currentVariantInCart(id);
      const remaining=Math.max(0,stock-already);
      if(stock<=0||remaining<=0){
        if(message)message.textContent=`Máximo en carrito (${already}/${stock}).`;
        return;
      }

      let quantity=Math.max(1,Number.parseInt(qtyInput?.value||'1',10)||1);
      quantity=Math.min(quantity,remaining);

      const r=await fetch('/cart/add.js',{
        method:'POST',
        headers:{Accept:'application/json','Content-Type':'application/json'},
        credentials:'same-origin',
        body:JSON.stringify({items:[{id:Number(id),quantity}]})
      });
      const data=await r.json().catch(()=>({}));
      if(!r.ok)throw new Error(data?.description||data?.message||`HTTP ${r.status}`);

      /* Segunda barrera: si Shopify/theme aceptó de más por carrera o carrito desactualizado, se corrige inmediatamente. */
      const finalQty=await enforceVariantCartLimit(id,stock);
      if(finalQty!=null && finalQty>=stock){
        if(message)message.textContent=`Agregado ✓ · ya tienes el máximo disponible (${stock}/${stock}).`;
      }else if(message){
        message.textContent='Agregado al carrito ✓';
      }
      add.textContent='Agregado ✓';
      await refreshThemeCart();
      await syncCartLimit(cardEl);
    }catch(err){
      console.warn('[TCG Singles cart]',err);
      if(message)message.textContent=`No se pudo agregar: ${String(err?.message||err)}`;
    }finally{
      commerceCartLocks.delete(id);
      window.setTimeout(async()=>{
        add.textContent=previous;
        await syncCartLimit(cardEl);
      },650);
    }
  }

  function attachCardZoom(host,rows){
    qa(host,'.btcg-card').forEach((cardEl,i)=>{
      const card=rows[i];
      if(!card)return;
      if(canFlipCard(card))warmBackImage(card);

      const zoom=cardEl.querySelector('[data-zoom-card]');
      if(zoom)zoom.addEventListener('click',()=>openLightbox(card));

      const variantSelect=cardEl.querySelector('[data-commerce-variant]');
      if(variantSelect){
        variantSelect.addEventListener('change',()=>{updateCommerceControls(cardEl);syncCartLimit(cardEl);});
        updateCommerceControls(cardEl);
        syncCartLimit(cardEl);
      }
      const qtyInput=cardEl.querySelector('[data-commerce-qty]');
      if(qtyInput)qtyInput.addEventListener('change',()=>{
        const max=Math.max(1,Number(qtyInput.max||1));
        let n=Math.max(1,Number.parseInt(qtyInput.value||'1',10)||1);
        qtyInput.value=String(Math.min(n,max));
      });
      const addButton=cardEl.querySelector('[data-commerce-add]');
      if(addButton)addButton.addEventListener('click',e=>{
        e.preventDefault();e.stopPropagation();addCommerceToCart(cardEl);
      });

      const flip=cardEl.querySelector('[data-flip-inline]');
      if(flip){
        const front=frontImage(card);
        const back=backImage(card);

        // Keep the control visible for a known double-faced card, but disable it
        // until Engine actually provides the physical back image.
        if(!canFlipCard(card)||!back){
          flip.disabled=true;
          flip.title='Reverso no disponible';
          return;
        }

        flip.dataset.face='front';
        flip.addEventListener('click',e=>{
          e.preventDefault();
          e.stopPropagation();

          const image=cardEl.querySelector('.btcg-card__image');
          if(!image)return;

          const showingBack=flip.dataset.face==='back';
          const nextBack=!showingBack;

          if(image.dataset.flipBusy==='1')return;
          image.dataset.flipBusy='1';
          image.classList.add('is-inline-flipping');
          const nextSrc=nextBack?back:front;

          window.setTimeout(()=>{
            image.src=nextSrc;
            image.alt=faceName(card,nextBack?1:0)||card.name||'Carta';
            flip.dataset.face=nextBack?'back':'front';
            flip.setAttribute('aria-label',nextBack?'Ver frente':'Ver reverso');
            flip.title=nextBack?'Ver frente':'Ver reverso';

            const typeLine=cardEl.querySelector('[data-card-face-type]');
            if(typeLine){
              const t=faceType(card,nextBack?1:0) || (nextBack?card.back_type_line||card.back_card_type:card.front_type_line||card.front_card_type) || '';
              if(t)typeLine.textContent=t;
            }

            window.setTimeout(()=>{
              image.classList.remove('is-inline-flipping');
              image.dataset.flipBusy='0';
            },120);
          },120);
        });
      }
    });
  }

  function lightboxCaption(card,showingBack){
    const index=showingBack?1:0;
    const name=faceName(card,index)||card.name||'Carta';
    const type=faceType(card,index)||(showingBack?card.back_type_line||card.back_card_type:'')||(showingBack?'':card.type_line||card.card_type||'');
    return [name,setCode(card),collector(card)?'#'+collector(card):'',type].filter(Boolean).join(' · ');
  }

  function openLightbox(card){
    const front=hiResImageUrl(frontImage(card)),back=hiResImageUrl(backImage(card));
    if(!front)return;

    state.lightbox={card,front,back,showingBack:false};
    const box=q(root,'[data-btcg-lightbox]');
    const img=q(root,'[data-btcg-lightbox-image]');

    img.src=front;
    img.alt=faceName(card,0)||card.name||'Carta';

    q(root,'[data-btcg-lightbox-caption]').textContent=lightboxCaption(card,false);
    const flip=q(root,'[data-btcg-lightbox-flip]');

    const flipReady=Boolean(canFlipCard(card)&&back);
    /* 062: fuerza el estado visual; hidden por sí solo puede ser anulado por CSS del theme. */
    if(!flipReady){
      flip.hidden=true;
      flip.disabled=true;
      flip.innerHTML='';
      flip.removeAttribute('aria-label');
      flip.removeAttribute('title');
      flip.style.setProperty('display','none','important');
    }else{
      flip.hidden=false;
      flip.disabled=false;
      flip.style.removeProperty('display');
      flip.innerHTML=handRotateSvg()+'<span class="visually-hidden">Ver reverso</span>';
      flip.setAttribute('aria-label','Ver reverso');
      flip.title='Ver reverso';
    }

    box.hidden=false;
    document.documentElement.classList.add('btcg-modal-open');
  }

  function closeLightbox(){
    q(root,'[data-btcg-lightbox]').hidden=true;
    state.lightbox=null;
    document.documentElement.classList.remove('btcg-modal-open');
  }

  function flipLightbox(){
    if(!state.lightbox?.back)return;

    state.lightbox.showingBack=!state.lightbox.showingBack;
    const img=q(root,'[data-btcg-lightbox-image]');
    const flip=q(root,'[data-btcg-lightbox-flip]');
    const card=state.lightbox.card;

    if(img.dataset.flipBusy==='1')return;
    img.dataset.flipBusy='1';
    img.classList.add('is-flipping');
    const back=state.lightbox.showingBack;
    const nextSrc=back?state.lightbox.back:state.lightbox.front;

    window.setTimeout(()=>{
      img.src=nextSrc;
      img.alt=faceName(card,back?1:0)||card.name||'Carta';
      q(root,'[data-btcg-lightbox-caption]').textContent=lightboxCaption(card,back);
      flip.setAttribute('aria-label',back?'Ver frente':'Ver reverso');
      flip.title=back?'Ver frente':'Ver reverso';

      window.setTimeout(()=>{
        img.classList.remove('is-flipping');
        img.dataset.flipBusy='0';
      },130);
    },130);
  }

  async function hydrateFromUrl(){
    const u=new URL(location.href);
    const ctx=await deriveCollectionContext();
    const game=ctx.game||gameKey(u.searchParams.get('game'));
    const set=ctx.set||String(u.searchParams.get('set')||'').toUpperCase();
    const metaArtist=String(u.searchParams.get('filter.artist')||'').trim();
    const metaSubtype=String(u.searchParams.get('filter.subtype')||'').trim();
    const metaType=String(u.searchParams.get('filter.type')||'').trim();
    const cardVersions=String(u.searchParams.get('filter.card')||'').trim();
    const hasMetaFilter=Boolean(metaArtist||metaSubtype||metaType||cardVersions);
    const mode=set?'sets':(u.searchParams.get('mode')||'cards');

    if(!game){show('home');return;}

    const btn=gameButtonFor(game);
    if(!btn){show('home');return;}

    state.game=game;state.gameName=btn.dataset.name||game;
    state.examples=String(btn.dataset.examples||'').split(',').map(x=>x.trim()).filter(Boolean);
    state.collectionManifest=null;

    renderGameHeading();
    await loadCollectionManifest();

    // Si una URL dinámica apunta a una colección SEO ya confirmada, migra al URL limpio
    // SIN perder los filtros que vienen desde la ficha de producto.
    if(!location.pathname.startsWith('/collections/')){
      const clean=set?knownSetCollection(set):knownGameCollection();
      if(clean){
        const target=new URL(clean,location.origin);

        ['filter.artist','filter.subtype','filter.type','filter.card'].forEach(key=>{
          const value=String(u.searchParams.get(key)||'').trim();
          if(value)target.searchParams.set(key,value);
        });

        // Los links de metadata siempre deben abrir la vista de cartas.
        if(hasMetaFilter||cardVersions)target.searchParams.set('mode','cards');

        location.replace(target.pathname+target.search);
        return;
      }
    }

    const initialMode=(location.pathname.startsWith('/collections/')&&!set&&!hasMetaFilter)?'sets':mode;
    show('game');setMode(initialMode,false,true);

    if(set){
      await loadSets();resetSetState();await openSet(set);
    }else if(cardVersions){
      await performCardVersionsSearch(cardVersions);
    }else if(hasMetaFilter){
      const metaKey=metaArtist?'artist':(metaSubtype?'subtype':'type');
      await performMetadataSearch(metaKey,metaArtist||metaSubtype||metaType);
    }
  }

  hydrateFromUrl();
}
})();